<template>
    <v-layout>
        <v-flex xs12>
            <v-progress-linear v-if="loading" :indeterminate="true"></v-progress-linear>
            <v-card v-if="!loading">
                <v-card-title class="accent white--text title">
                    <span v-if="!editedView">{{'Custom View Builder'|translate}}</span>
                    <span v-if="editedView">{{'Edit Custom View'|translate}} : {{editedView.title}}</span>
                </v-card-title>
                <v-card-text style="padding-top: 0; bottom: 0;">
                    <v-layout row>
                        <v-flex xs2>
                            <date-range-selector v-model="range"></date-range-selector>
                        </v-flex>
                        <v-flex xs2 v-if="editedView" class="mx-4 px-4">
                            <v-select
                                    :items="defaultRanges"
                                    clearable
                                    :label="'Default Date Range'|translate"
                                    v-model="editedView.defaultRange"
                            ></v-select>
                        </v-flex>
                        <v-spacer></v-spacer>
                        <div style="height: 24px; margin-right: 12px;" v-if="editedView">
                            <v-switch color="success"
                                      v-model="editedView.hideRangeSelector"
                                      :label="'Hide Date'|translate"
                            ></v-switch>
                        </div>
                        <div style="height: 24px; margin-right: 12px;" v-if="editedView&&!editedView.hideRangeSelector">
                            <v-switch color="success"
                                      v-model="editedView.dateIconMode"
                                      :label="'Only Icon'|translate"
                            ></v-switch>
                        </div>
                        <div style="height: 24px; margin-right: 12px;" v-if="editedView&&!editedView.hideRangeSelector">
                            <v-switch color="success"
                                      v-model="editedView.monthMode"
                                      :label="'Monthly'|translate"
                            ></v-switch>
                        </div>
                        <div style="height: 24px; margin-right: 12px;" v-if="editedView&&!editedView.hideRangeSelector&&editedView.monthMode">
                            <v-switch color="success"
                                      v-model="editedView.useCustomMonth"
                                      :label="'Custom Month'|translate"
                            ></v-switch>
                        </div>
                        <div style="height: 24px; margin-right: 12px;" v-if="editedView&&!editedView.hideRangeSelector&&editedView.monthMode">
                            <v-switch color="success"
                                      v-model="editedView.useMonthRange"
                                      :label="'Month Range'|translate"
                            ></v-switch>
                        </div>
                        <div style="height: 24px; margin-right: 12px;" v-if="editedView&&!editedView.renderInFullScreen">
                            <v-switch color="success"
                                      v-model="editedView.renderAsReport"
                                      :label="'Report'|translate"
                            ></v-switch>
                        </div>
                        <div style="height: 24px; margin-right: 12px;" v-if="editedView&&!editedView.renderAsReport">
                            <v-switch color="success"
                                      v-model="editedView.renderInFullScreen"
                                      :label="'Fullscreen'|translate"
                            ></v-switch>
                        </div>
                        <div style="height: 24px; margin-right: 12px;" v-if="editedView&&whiteModeIsRelevant">
                            <v-switch color="success"
                                      v-model="editedView.whiteMode"
                                      :label="'White'|translate"
                            ></v-switch>
                        </div>
                        <v-flex xs2 class="pr-4" v-if="editedView">
                            <v-text-field :label="'Title'|translate" v-model="editedView.title" required></v-text-field>
                        </v-flex>
                        <v-flex xs1 v-if="editedView">
                            <v-text-field :label="'Link Title'|translate" v-model="editedView.linkTitle" required></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row v-if="editedView&&!editedView.hideRangeSelector&&editedView.monthMode">
                        <v-spacer></v-spacer>
                        <div style="height: 24px; margin-right: 12px;" v-if="editedView.useMonthRange">
                            <v-switch color="success"
                                      v-model="editedView.lockStartRange"
                                      :label="'Lock Start'|translate"
                            ></v-switch>
                        </div>
                        <v-flex xs2 class="pr-4">
                            <v-text-field :label="'Min Start Date'|translate" type="month"  v-model="editedView.customMonthMin" clearable></v-text-field>
                        </v-flex>
                        <v-flex xs6 class="pr-4" v-if="editedView.useCustomMonth">
                            <v-textarea :label="'Custom Month Configuration'|translate" v-model="editedView.customMonthRangeJson" rows="2">
                            </v-textarea>
                        </v-flex>
                    </v-layout>
                    <v-layout row v-if="editedView">
                        <v-spacer></v-spacer>
                        <div style="height: 36px; margin-right: 12px;">
                            <v-switch color="success"
                                      v-model="editedView.hasOnOnlySwitch"
                                      :label="'On Only Switch'|translate"
                            ></v-switch>
                        </div>
                        <div style="height: 36px; margin-right: 12px;">
                            <v-switch color="success"
                                      v-model="editedView.hasEquipmentSelector"
                                      :label="'Equip Select'|translate"
                            ></v-switch>
                        </div>

                        <div style="height: 36px; margin-right: 12px;" v-if="editedView.hasEquipmentSelector">
                            <v-switch color="success"
                                      v-model="editedView.allEquipsMode"
                                      :label="'Repeat for each'|translate"
                            ></v-switch>
                        </div>
                        <div style="height: 36px; margin-right: 12px;" v-if="editedView.hasEquipmentSelector">
                            <v-btn @click="equipSetDefaultDialog=true" class="primary mr-2">{{'Update Queries'|translate}} </v-btn>
                        </div>
                        <v-flex xs2 class="pr-4" v-if="editedView.hasEquipmentSelector">
                            <v-combobox
                                :items="typeFilters"
                                :label="'Equipment Type filter'|translate"
                                v-model="editedView.equipmentTypeFilter"
                                clearable
                            ></v-combobox>
                        </v-flex>
                        <v-flex xs2 class="pr-4" v-if="editedView.hasEquipmentSelector">
                            <v-combobox
                                :items="floorFilters"
                                :label="'Equipment Floor filter'|translate"
                                v-model="editedView.equipmentFloorFilter"
                                clearable
                            ></v-combobox>
                        </v-flex>
                        <v-flex xs2 class="pr-4" v-if="editedView.hasEquipmentSelector">
                            <v-text-field
                                :label="'Equipment Tag filter'|translate"
                                :hint="'Comma-separated list of tags'|translate"
                                v-model="editedView.equipmentTagFilter"
                                clearable
                            ></v-text-field>
                        </v-flex>
                        <div style="height: 36px; margin-right: 12px;" v-if="!editedView.renderAsReport">
                            <v-switch color="success"
                                      v-model="editedView.enforceMinWidth"
                                      :label="'Min Width'|translate"
                            ></v-switch>
                        </div>
                        <div style="height: 36px; margin-right: 12px;" v-if="!editedView.renderAsReport">
                            <v-switch color="success"
                                      v-model="editedView.showBoxes"
                                      :label="'Borders'|translate"
                            ></v-switch>
                        </div>
                        <v-flex xs2 class="pr-4" v-if="editedView.showBoxes">
                            <v-text-field
                                :label="'Background color'|translate"
                                v-model="editedView.backgroundColor"
                                clearable
                            ></v-text-field>
                        </v-flex>
                        <div style="height: 36px; margin-right: 12px;" v-if="$can('update', 'Config')">
                            <v-switch color="success"
                                      v-model="editedView.restrictedAccess"
                                      :label="'Restricted Access'|translate"
                            ></v-switch>
                        </div>
                        <v-flex xs2 class="pr-4" v-if="$can('update', 'Config')&&editedView.restrictedAccess">
                            <v-text-field
                                :label="'Namespace'|translate"
                                v-model="editedView.namespace"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                    <v-layout row v-if="editedView&&editedView.renderAsReport">
                        <v-spacer></v-spacer>
                        <div style="height: 24px; margin-right: 12px;">
                            <v-switch color="success"
                                      v-model="editedView.disableCoverPage"
                                      :label="'Disable cover page'|translate"
                            ></v-switch>
                        </div>
                        <v-flex xs1 class="pr-4">
                            <image-picker :label="'Logo URL'|translate" v-model="editedView.customLogo"></image-picker>
                        </v-flex>
                        <v-flex xs2 class="pr-4">
                            <v-text-field :label="'Subtitle'|translate" v-model="editedView.subtitle" clearable></v-text-field>
                        </v-flex>
                        <v-flex xs1>
                            <v-text-field :label="'Brand name'|translate" v-model="editedView.brandName" clearable></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-card v-if="!loading" v-bind:class="[editedView&&editedView.renderAsReport ? 'carnot-custom-report': null,editedView&&editedView.renderAsReport&&whiteMode ? 'carnot-custom-report-white': null]"
                    :light="editedView&&whiteMode">
                <v-card-text style="padding-top: 0; min-height: 400px;" :style="editedView&&editedView.showBoxes&&!editedView.renderAsReport&&editedView.backgroundColor ? 'background-color:'+editedView.backgroundColor : ''">
                    <v-layout row wrap>
                        <v-flex v-for="(plot,index) in plotList" :key="plot.id"  v-bind:class="[plot['flex-class'], 'xs12', plot['pageBreak'] ? 'page-break': null ]" >
                            <data3-chart ref="plots" v-if="plot.type==='data3-chart'"
                                         :layout-overrides="plot.config['layout-overrides']"
                                         :x-axis="plot.config['x-axis']"
                                         :y-axis="plot.config['y-axis']"
                                         :color-axis="plot.config['color-axis']"
                                         :marker-size-axis="plot.config['marker-size-axis']"
                                         :color-axis-scale="plot.config['color-axis-scale']"
                                         :color-axis-title="plot.config['color-axis-title']"
                                         :white-mode="editedView&&whiteMode"
                                         :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                         :parameters="parameters"
                                         disable-responsive
                                         show-units
                                         :data-payload="plot.config['data-payload']"
                                         :independent-x="plot.config['independent-x']"
                                         :series-overrides="plot.config['series-overrides']"
                                         :date-range="range"></data3-chart>
                            <inline-editor v-model="plot.config.html" v-if="plot.type==='html'" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "></inline-editor>
                            <div v-if="plot.type==='code'&&!plot.editDialog" v-html="plot.config.html" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "></div>
                            <div v-if="plot.type==='parameter-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' ">
                                <v-card flat v-if="plot.config.fields">
                                    <v-card-text>
                                        <v-layout row wrap>
                                            <v-flex xs12 v-for="field in plot.config.fields" v-if="field.name">
                                                <v-slider
                                                    :label="field.label"
                                                    v-model.number="parameters[field.name]"
                                                    :min="field.min"
                                                    :max="field.max"
                                                    :step="field.step"
                                                    thumb-label="always"
                                                ></v-slider>
                                            </v-flex>
                                        </v-layout>
                                    </v-card-text>
                                </v-card>
                            </div>
                            <map-widget v-if="plot.type==='map-widget'&&!plot.editDialog"
                                        :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                        :height="plot.config.height"
                                        :map-token="plot.config.mapToken"
                                        :map-style="plot.config.mapStyle"
                                        :pitch="plot.config.pitch"
                                        :zoom="plot.config.zoom"
                                        :center-lon="plot.config.centerLon"
                                        :center-lat="plot.config.centerLat"
                                        :markers="plot.config.markers"
                                        :date-range="range"
                                        :data3query="plot.config.data3query"
                                        :colors="plot.config.colors"
                            ></map-widget>
                            <solar-widget v-if="plot.type==='solar-widget'&&!plot.editDialog"
                                          :height="plot.config.height"
                                          :lat="plot.config.lat"
                                          :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                          :lon="plot.config.lon"
                                          :features-json="plot.config.featuresJson"
                                          :date-range="range"
                                          :white-mode="editedView&&whiteMode"
                                          :show-clock="plot.config.showClock"
                                          :main-intensity="plot.config.mainIntensity"
                                          :ambient-intensity="plot.config.ambientIntensity"
                            ></solar-widget>
                            <form-widget v-if="plot.type==='form-widget'&&!plot.editDialog"
                                          :title="plot.config.title"
                                          :description="plot.config.description"
                                         :table-mode="plot.config.tableMode"
                                         :multiple-mode="plot.config.multipleMode"
                                          :fields="plot.config.fields"
                                          :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                            ></form-widget>
                            <heatmap-widget v-if="plot.type==='heatmap-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                            :date-range="range"
                                        :height="plot.config.height"
                                        :width="plot.config.width"
                                        :min="plot.config.min"
                                        :max="plot.config.max"
                                        :image-url="plot.config.imageUrl"
                                        :points="plot.config.points"
                                        :agg="plot.config.agg"
                                        :agg-opp="plot.config.aggOpp"
                                        :options="plot.config.options"
                                        :on-only="plot.config.onOnly"
                                        :player="plot.config.player"
                            ></heatmap-widget>
                            <correlation-widget v-if="plot.type==='correlation-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                :date-range="range"
                                                :white-mode="editedView&&whiteMode"
                                                :equipment-name="plot.config.equipmentName">
                            </correlation-widget>
                            <optimization-widget v-if="plot.type==='optimization-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                 :custom-interpolation="plot.config.customInterpolation"
                                                 :interpolation="plot.config.interpolation"
                                                 :power-sensor="plot.config.powerSensor"
                                                 :exact-power-sensor="plot.config.exactPowerSensor"
                                                 :weather-sensor="plot.config.weatherSensor"
                                                 :weather-agg="plot.config.weatherAgg"
                                                 :weather-title="plot.config.weatherTitle"
                                                 :use-switch="plot.config.useSwitch"
                                                 :title="plot.config.title"
                                                 :start-date="plot.config.startDate"
                                                 :end-date="plot.config.endDate"
                                                 :white-mode="editedView&&whiteMode"
                                                 :cut-off="plot.config.cutOff"
                                                 :switch-sensor="plot.config.switchSensor"
                                                 :min-power="plot.config.minPower"
                                                 :max-power="plot.config.maxPower"
                                                 :min-temp="plot.config.minTemp"
                                                 :hide-kpi="plot.config.hideKpi"
                                                 :max-temp="plot.config.maxTemp"
                                                 :agg-frequency="plot.config.aggFrequency"
                                                 :ec-mode="plot.config.ecMode"
                                                 :date-range="range"></optimization-widget>
                            <flexible-optimization-widget v-if="plot.type==='flexible-optimization-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                 :custom-interpolation="plot.config.customInterpolation"
                                                 :interpolation="plot.config.interpolation"
                                                 :power-sensor="plot.config.powerSensor"
                                                 :weather-sensor="plot.config.weatherSensor"
                                                 :weather-title="plot.config.weatherTitle"
                                                 :use-switch="plot.config.useSwitch"
                                                 :title="plot.config.title"
                                                 :start-date="plot.config.startDate"
                                                 :end-date="plot.config.endDate"
                                                          :resampling-factor="plot.config.resamplingFactor"
                                                 :white-mode="editedView&&whiteMode"
                                                          :show-negative-monthly="plot.config.showNegativeMonthly"
                                                 :cut-off="plot.config.cutOff"
                                                 :parameters="parameters"
                                                 :switch-sensor="plot.config.switchSensor"
                                                 :min-temp="plot.config.minTemp"
                                                 :hide-kpi="plot.config.hideKpi"
                                                 :max-temp="plot.config.maxTemp"
                                                 :ec-mode="plot.config.ecMode"
                                                 :show-calc="plot.config.showCalc"
                                                 :data3query="plot.config.data3query"
                                                 :date-range="range"></flexible-optimization-widget>
                            <cop-savings-widget v-if="plot.type==='cop-savings-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                 :custom-interpolation="plot.config.customInterpolation"
                                                 :interpolation="plot.config.interpolation"
                                                 :power-sensor="plot.config.powerSensor"
                                                 :cooling-load-sensor="plot.config.coolingLoadSensor"
                                                 :title="plot.config.title"
                                                 :start-date="plot.config.startDate"
                                                 :end-date="plot.config.endDate"
                                                 :cut-off="plot.config.cutOff"
                                                 :switch-sensor="plot.config.switchSensor"
                                                 :use-switch="plot.config.useSwitch"
                                                 :min-power="plot.config.minPower"
                                                 :white-mode="editedView&&whiteMode"
                                                 :max-power="plot.config.maxPower"
                                                 :use-filter="plot.config.useFilter"
                                                 :filter-sensor="plot.config.filterSensor"
                                                :hide-kpi="plot.config.hideKpi"
                                                 :max-filter="plot.config.maxFilter"
                                                 :min-filter="plot.config.minFilter"
                                                 :min-cooling-load="plot.config.minCoolingLoad"
                                                 :max-cooling-load="plot.config.maxCoolingLoad"
                                                 :agg-frequency="plot.config.aggFrequency"
                                                 :show-mean-cop="plot.config.showMeanCop"
                                                 :ec-mode="plot.config.ecMode"
                                                 :date-range="range"></cop-savings-widget>
                            <flexible-cop-savings-widget v-if="plot.type==='flexible-cop-savings-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                 :custom-interpolation="plot.config.customInterpolation"
                                                 :interpolation="plot.config.interpolation"
                                                         :post-interpolation="plot.config.postInterpolation"
                                                         :custom-post-interpolation="plot.config.customPostInterpolation"
                                                 :power-sensor="plot.config.powerSensor"
                                                 :cooling-load-sensor="plot.config.coolingLoadSensor"
                                                 :title="plot.config.title"
                                                 :start-date="plot.config.startDate"
                                                 :end-date="plot.config.endDate"
                                                :data3query="plot.config.data3query"
                                                :parameters="parameters"
                                                 :cut-off="plot.config.cutOff"
                                                 :switch-sensor="plot.config.switchSensor"
                                                 :use-switch="plot.config.useSwitch"
                                                 :white-mode="editedView&&whiteMode"
                                                         :resampling-factor="plot.config.resamplingFactor"
                                                :hide-kpi="plot.config.hideKpi"
                                                 :show-mean-cop="plot.config.showMeanCop"
                                                         :show-copy-btn="plot.config.showCopyBtn"
                                                         :post-interpolation-points="plot.config.postInterpolationPoints"
                                                 :ec-mode="plot.config.ecMode"
                                                         :show-negative-monthly="plot.config.showNegativeMonthly"
                                                 :span="plot.config.span"
                                                 :band="plot.config.band"
                                                 :degree="plot.config.degree"
                                                 :date-range="range"></flexible-cop-savings-widget>
                            <fault-breakdown-widget v-if="plot.type==='fdd-breakdown-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :vertical="plot.config.vertical"
                                                    :group-mode="plot.config.groupMode"
                                                    :white-mode="editedView&&whiteMode"
                                                    :hide-table="plot.config.hideTable"
                                                    :critical-color="plot.config.criticalColor"
                                                    :high-color="plot.config.highColor"
                                                    :medium-color="plot.config.mediumColor"
                                                    :low-color="plot.config.lowColor"
                                                    :colorway="plot.config.colorway"
                                                    :title1="plot.config.title1"
                                                    :title2="plot.config.title2"
                                                    :label-margin="plot.config.labelMargin"
                                                :date-range="range"></fault-breakdown-widget>
                            <notif-breakdown-widget v-if="plot.type==='notif-breakdown-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :white-mode="editedView&&whiteMode"
                                                    :title="plot.config.title"
                                                    :facet="plot.config.facet"
                                                    :height="plot.config.height"
                                                    :limit="plot.config.limit"
                                                :date-range="range"></notif-breakdown-widget>
                            <fault-eval-widget v-if="plot.type==='fault-eval-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :rule="plot.config.rule"
                                                    :title="plot.config.title"
                                                    :value="plot.config.value"
                                                    :cost="plot.config.cost"
                                                    :equipment-name="plot.config.equipmentName"
                                                    :relevant-variables="plot.config.relevantVariables"
                                                    :white-mode="editedView&&whiteMode"
                                                    :on-only="plot.config.onOnly"
                                                    :show-cost="plot.config.showCost"
                                                :date-range="range"></fault-eval-widget>
                          <staging-profile-widget v-if="plot.type==='staging-profile-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :white-mode="editedView&&whiteMode"
                                                    :y-title="plot.config.yTitle"
                                                :date-range="range"></staging-profile-widget>
                            <faults-report-widget v-if="plot.type==='faults-report-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :show-anomaly="plot.config.showAnomaly"
                                                    :show-summary="plot.config.showSummary"
                                                    :show-faults="plot.config.showFaults"
                                                    :severity-filter="plot.config.severityFilter"
                                                    :report-mode="editedView&&editedView.renderAsReport"
                                                    :white-mode="editedView&&whiteMode"
                                                :date-range="range"></faults-report-widget>
                          <cooling-load-forecast-widget v-if="plot.type==='cooling-load-forecast-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :y-title="plot.config.yTitle"
                                                    :result-name="plot.config.resultName"
                                                        :days-before="plot.config.daysBefore"
                                                    :expected-value-legend="plot.config.expectedValueLegend"
                                                    :fitted-value-legend="plot.config.fittedValueLegend"
                                                    :actual-observed-value-legend="plot.config.actualObservedValueLegend"
                                                    :white-mode="editedView&&whiteMode"
                                                    :confidence-interval-legend="plot.config.confidenceIntervalLegend"
                                                ></cooling-load-forecast-widget>
                            <sensor-calibration-widget v-if="plot.type==='sensor-calibration-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                           :title="plot.config.title"
                                                           :conf="plot.config.conf"
                                                           :date-range="range"
                                                           :white-mode="editedView&&whiteMode"
                            ></sensor-calibration-widget>
                        <chiller-sequencing-fla-widget v-if="plot.type==='chiller-sequencing-fla-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :y-title="plot.config.yTitle"
                                                    :date-range="range"
                                                       :white-mode="editedView&&whiteMode"
                                                ></chiller-sequencing-fla-widget>
                        <chiller-sequencing-delta-widget v-if="plot.type==='chiller-sequencing-delta-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :y-title="plot.config.yTitle"
                                                    :date-range="range"
                                                         :white-mode="editedView&&whiteMode"
                                                ></chiller-sequencing-delta-widget>
                            <clock-control-widget v-if="plot.type==='clock-control-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                             v-model="range"
                                                  :target="plot.config.target"
                                                  :title="plot.config.title"
                                                  :animate-mode="plot.config.animateMode"
                                                  :frame-duration="plot.config.frameDuration"
                                                  :frame-multiplier="plot.config.frameMultiplier"
                                                  :loop="plot.config.loop"
                            ></clock-control-widget>
                        <cooling-load-vs-oat-widget v-if="plot.type==='cooling-load-vs-oat-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :title="plot.config.title"
                                                    :x-title="plot.config.xTitle"
                                                    :y-title="plot.config.yTitle"
                                                    :white-mode="editedView&&whiteMode"
                                                    :date-range="range"></cooling-load-vs-oat-widget>
                            <bms-widget v-if="plot.type==='bms-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :title="plot.config.title"
                                                    :latest-only="plot.config.latestOnly"
                                                    :svg="plot.config.svg"></bms-widget>
                            <svg-widget v-if="plot.type==='svg-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                        :data3query="plot.config.data3query"
                                        :parameters="parameters"
                                        :date-range="range"
                                        :style="plot.config.verticalOffset&&!disableVerticalOffset ? 'height:0px;' : ''"
                                        :vertical-offset="plot.config.verticalOffset&&!disableVerticalOffset ? plot.config.verticalOffset : null"
                                        :include-issues="plot.config.includeIssues"
                                        :include-maintenance="plot.config.includeMaintenance"
                                        :no-reload="plot.config.noReload"
                                        :include-config="plot.config.includeConfig"
                                        :svg="plot.config.svg"></svg-widget>
                            <maintenance-summary-widget v-if="plot.type==='maintenance-summary-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                        :title="plot.config.title"
                                                        :title2="plot.config.title2"
                                                        :height="plot.config.height"
                                                        :white-mode="editedView&&whiteMode"
                                                        :date-range="range"
                            ></maintenance-summary-widget>
                            <issue-summary-widget v-if="plot.type==='issue-summary-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                        :title="plot.config.title"
                                                        :title2="plot.config.title2"
                                                        :title3="plot.config.title3"
                                                        :height="plot.config.height"
                                                        :white-mode="editedView&&whiteMode"
                                                        :date-range="range"
                            ></issue-summary-widget>
                            <forge-viewer-widget v-if="plot.type==='forge-viewer-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                    :selected-items="[plot.config.selectedItemID]"
                                                    :selection-color="plot.config.selectionColor"
                                                 :url="plot.config.url"
                                                 :white-mode="editedView&&whiteMode"
                                                 :use-min-height="plot.config.useMinHeight"
                                                 :height="plot.config.height"></forge-viewer-widget>
                            <cost-breakdown-widget v-if="plot.type==='cost-breakdown-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                 :height="plot.config.height"
                                                 :leftmarg="plot.config.leftmarg"
                                                   :white-mode="editedView&&whiteMode"
                                                 :date-range="range"></cost-breakdown-widget>
                            <tree-map-widget v-if="plot.type==='tree-map-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                             :title="plot.config.title"
                                             :power-sensor="plot.config.powerSensor"
                                             :agg-frequency="plot.config.aggFrequency"
                                             :height="plot.config.height"
                                             :unit="plot.config.unit"
                                             :white-mode="editedView&&whiteMode"
                                             :date-range="range"
                                                ></tree-map-widget>
                            <thermal-comfort-widget v-if="plot.type==='thermal-comfort-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                             :title="plot.config.title"
                                             :height="plot.config.height"
                                             :dryBulbTemp="plot.config.dryBulbTemp"
                                             :relativeHumidity="plot.config.relativeHumidity"
                                             :airSpeed="plot.config.airSpeed"
                                             :metabolicRate="plot.config.metabolicRate"
                                             :clothingLevel="plot.config.clothingLevel"
                                                    :hide-parameters="plot.config.hideParameters"
                                                    :hide-temp-scale="plot.config.hideTempScale"
                                             :white-mode="editedView&&whiteMode"
                                             :date-range="range"
                                             :data3query="plot.config.data3query"
                                             :parameters="parameters"
                                                    :enable-solar="plot.config.enableSolar"
                                                    :solar-altitude="plot.config.solarAltitude"
                                                    :solar-azimuth="plot.config.solarAzimuth"
                                                    :solar-irradiance="plot.config.solarIrradiance"
                                                    :solar-transmittance="plot.config.solarTransmittance"
                                                    :f_svv="plot.config.f_svv"
                                                    :f_bes="plot.config.f_bes"
                                                    :asw="plot.config.asw"
                            ></thermal-comfort-widget>
                            <forge-viewer-heatmap-widget
                                v-if="plot.type==='forge-viewer-heatmap-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                :url="plot.config.url"
                                :date-range="range"
                                :points="plot.config.points"
                                :surface-id="plot.config.surfaceId"
                                :floor-name="plot.config.floorName"
                                :agg="plot.config.agg"
                                :agg-opp="plot.config.aggOpp"
                                :on-only="plot.config.onOnly"
                                :white-mode="editedView&&whiteMode"
                                :height="plot.config.height"></forge-viewer-heatmap-widget>
                            <custom-ec-widget v-if="plot.type==='custom-ec-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                              :date-range="range"
                                              :processor-function="plot.config.processorFunction"
                                              :style="plot.config.verticalOffset&&!disableVerticalOffset ? 'height:0px;' : ''"
                                              :vertical-offset="plot.config.verticalOffset&&!disableVerticalOffset ? plot.config.verticalOffset : null"
                                              :data3query="plot.config.data3query"
                                              :parameters="parameters"
                                         :timer="plot.config.timer"
                                              :no-reload="plot.config.noReload"
                                         :animation-mode="plot.config.animationMode"
                                         :enable-merge="plot.config.enableMerge"
                                         :white-mode="editedView&&whiteMode"
                                         :height="plot.config.height"
                                              :settings="plot.config.settings"
                            ></custom-ec-widget>
                            <optimization-control-widget v-if="plot.type==='optimization-control-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                              :date-range="range"
                                         :white-mode="editedView&&whiteMode"
                                                         :default-equipment="plot.config.defaultEquipment"
                                                         :follow-equipment="plot.config.followEquipment"
                                                         :use-relationship="plot.config.useRelationship"
                                                         :relationship-type="plot.config.relationshipType"
                                                         :specific-sensors="plot.config.specificSensors"
                                                         :col-width="plot.config.colWidth"
                                                         :show-priorities="plot.config.showPriorities"
                                                         :equipment-col-width="plot.config.equipmentColWidth"
                            ></optimization-control-widget>
                            <data-export-widget v-if="plot.type==='data-export-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                              :date-range="range"
                                              :data3query="plot.config.data3query"
                                              :parameters="parameters"
                                         :title="plot.config.title"
                                                :file-name="plot.config.fileName"
                                                :include-range-in-name="plot.config.includeRangeInName"
                            ></data-export-widget>
                            <optimization-viz-widget v-if="plot.type==='optimization-viz-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                :date-range="range"
                                                :data3query="plot.config.data3query"
                                                :parameters="parameters"
                                                :title="plot.config.title"
                                                     :target="plot.config.target"
                                                     :white-mode="editedView&&whiteMode"
                                                     :height="plot.config.height"
                                                     :increment="plot.config.increment"
                            ></optimization-viz-widget>
                            <equipment-graphic-renderer v-if="plot.type==='graphic-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                                        :graphic-id="plot.config.graphic_id"
                                                        :menu-mode="plot.config.menuMode"
                                                        :menu-path="plot.config.menuPath"
                                                        :health-mode="plot.config.healthMode"
                                                        :use-min-height="plot.config.useMinHeight"
                                                        :date-range="range"
                                                        :lighting-preset="plot.config.lightingPreset"
                                                        :height="plot.config.height"
                                                        :ground-shadow="plot.config.groundShadow"
                                                        :ground-reflection="plot.config.groundReflection"
                                                        :node-names-to-hide="plot.config.nodeNamesToHide"
                                                        :node-names-to-remove="plot.config.nodeNamesToRemove"
                                                        :mode-name-to-focus="plot.config.modeNameToFocus"
                                                        :forced-background="plot.config.forcedBackground"
                                                        :lock-nav="plot.config.lockNav"
                            ></equipment-graphic-renderer>
                            <autotuner-widget v-if="plot.type==='autotuner-widget'&&!plot.editDialog" :class="editedView&&(editedView.showBoxes||plot.showBox)&&!editedView.renderAsReport ? 'elevation-2 ma-3': '' "
                                              :autotuner-id="plot.config.autotunerId"
                                              :title="plot.config.title"
                                              :white-mode="editedView&&whiteMode"
                                              :height="plot.config.height"
                                              :date-range="range"
                            ></autotuner-widget>
                            <v-layout row v-show="!hideControls">
                                <v-spacer></v-spacer>
                                <div style="width: 50px;">
                                    <v-select class="mt-0"
                                            :items="flexClasses"
                                            :label="'Width'|translate"
                                            placeholder="12"
                                            v-model="plot['flex-class']"
                                    ></v-select>
                                </div>
                                <div v-if="editedView&&editedView.renderAsReport" style="height: 24px; margin-right: 8px; margin-left: 8px;"><v-switch color="success" class="mt-0"
                                                                                         v-model="plot['pageBreak']"
                                                                                         :label="'BR'|translate"
                                ></v-switch></div>
                                <div v-if="editedView&&!editedView.renderAsReport" style="height: 24px; margin-right: 8px; margin-left: 8px;"><v-switch color="success" class="mt-0"
                                                                                                                                                       v-model="plot['showBox']"
                                                                                                                                                       :label="'Border'|translate"
                                ></v-switch></div>
                                    <v-icon small class="ml-2 mr-2" v-if="index>0" @click="arrmove(plotList,index,index-1)">
                                        fa-arrow-up
                                    </v-icon>
                                    <v-icon small class="mr-2" v-if="index<plotList.length-1" @click="arrmove(plotList,index,index+1)">
                                        fa-arrow-down
                                    </v-icon>
                                    <v-icon small class="mr-2" v-if="plot.type!=='html'" @click="editingIndex=index; plot.editDialog=true">
                                        fa-edit
                                    </v-icon>
                                    <v-icon small class="mr-2" @click="insertionPoint=index+1; masterDialog=true">
                                        fa-plus
                                    </v-icon>
                                    <v-icon small class="mr-2" @click="copyChart(plot)">
                                        fa-copy
                                    </v-icon>
                                    <v-icon small class="mr-2" @click="exportChart(plot)">
                                        fa-file-export
                                    </v-icon>
                                    <v-icon small class="mr-2" @click="deleteItem(index)">
                                        fa-trash
                                    </v-icon>
                                <v-dialog v-if="plot.type==='data3-chart'&&plot.editDialog" v-model="plot.editDialog" fullscreen persistent>
                                    <chart-builder v-if="plot.editDialog" :callback="handleCBEdit" :initial-value="plot.config" :default-range="range" v-on:close="plot.editDialog=false" :parameters="parameters" :equipment-relationships="equipmentRelationships"></chart-builder>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='map-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Map'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs6>
                                                    <v-text-field :label="'Height'|translate"  v-model.number="plot.config.height"></v-text-field>
                                                    <v-text-field :label="'Pitch'|translate"  v-model.number="plot.config.pitch"></v-text-field>
                                                    <v-text-field :label="'Zoom'|translate"  v-model.number="plot.config.zoom"></v-text-field>
                                                </v-flex>
                                                <v-flex xs6 class="pl-3">
                                                    <v-text-field :label="'Center Latitude'|translate"  v-model.number="plot.config.centerLon"></v-text-field>
                                                    <v-text-field :label="'Center Longitude'|translate"  v-model.number="plot.config.centerLat"></v-text-field>
                                                    <v-text-field :label="'Custom Style'|translate"  v-model="plot.config.mapStyle" clearable></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-title class="primary white--text subheading">
                                            {{'Markers'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(marker,markerIndex) in plot.config.markers">
                                                    <v-layout row wrap>
                                                        <v-flex xs5>
                                                            <v-text-field :label="'Name'|translate"  v-model="marker.name"></v-text-field>
                                                            <v-text-field :label="'Image URL'|translate"  v-model="marker.thumb"></v-text-field>
                                                            <v-text-field :label="'Color Series'|translate"  v-model="marker.colorSeries"></v-text-field>
                                                            <v-text-field :label="'Link URL'|translate"  v-model="marker.link"></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs5 class="pl-3">
                                                            <v-text-field :label="'Latitude'|translate"  v-model.number="marker.lon"></v-text-field>
                                                            <v-text-field :label="'Longitude'|translate"  v-model.number="marker.lat"></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs2>
                                                            <v-layout row>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="primary" @click="plot.config.markers.splice(markerIndex,1)">
                                                                <v-icon class="mr-2" small>
                                                                    fa-trash
                                                                </v-icon>
                                                                {{'Delete'|translate}}
                                                            </v-btn>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider></v-divider>
                                                </v-flex>
                                            </v-layout>

                                        </v-card-text>
                                        <v-card-title class="primary white--text subheading" v-if="plot.config.colors&&plot.config.colors.length>0">
                                            {{'Colors'|translate}}
                                        </v-card-title>
                                        <v-card-text v-if="plot.config.colors&&plot.config.colors.length>0">
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(color,colorIndex) in plot.config.colors">
                                                    <v-layout row wrap>
                                                        <v-flex xs5>
                                                            <v-text-field :label="'Min'|translate"  v-model.number="color.min"></v-text-field>
                                                            <v-text-field :label="'Max'|translate"  v-model.number="color.max"></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs5 class="pl-3">
                                                            <v-text-field v-model="color.value" type="text"
                                                                          :label="'Color'|translate">
                                                                <template v-slot:prepend>
                                                                    <v-icon v-show="color.value" v-bind:style="{ color: color.value }">fa-tint</v-icon>
                                                                </template>

                                                            </v-text-field>
                                                        </v-flex>
                                                        <v-flex xs2>
                                                            <v-layout row>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="primary" @click="plot.config.colors.splice(colorIndex,1)">
                                                                    <v-icon class="mr-2" small>
                                                                        fa-trash
                                                                    </v-icon>
                                                                    {{'Delete'|translate}}
                                                                </v-btn>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider></v-divider>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>

                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="cbInternalDiag5=true" v-if="!plot.config.data3query" class="mr-2">{{'Add Data Query'|translate}} </v-btn>
                                            <v-btn @click="cbInternalDiag5=true" v-if="plot.config.data3query" class="mr-2">{{'Edit Data Query'|translate}} </v-btn>
                                            <v-dialog v-model="cbInternalDiag5" fullscreen persistent>
                                                <chart-builder v-if="cbInternalDiag5" headless-mode :callback="(cfg)=>{plot.config.data3query=cfg}" :initial-value="plot.config.data3query" :default-range="range" v-on:close="cbInternalDiag5=false" :equipment-relationships="equipmentRelationships"></chart-builder>
                                            </v-dialog>
                                            <v-btn @click="plot.config.markers.push({lon:114.1584,lat:22.282225,name:'New Marker'})" class="mr-2">{{'Add Marker'|translate}}</v-btn>
                                            <v-btn @click="plot.config.colors.push({min:0,max:10,value:'#00CF27'})" class="mr-2">{{'Add Color Step'|translate}}</v-btn>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='form-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1500" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Form'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-text-field :label="'Title'|translate"  v-model="plot.config.title"></v-text-field>
                                                    <v-textarea :label="'Description'|translate" v-model="plot.config.description" rows="2">
                                                    </v-textarea>
                                                    <v-switch color="success"
                                                              v-model="plot.config.tableMode"
                                                              :label="'Render as table'|translate"
                                                    ></v-switch>
                                                    <v-switch color="success"
                                                              v-model="plot.config.multipleMode"
                                                              v-if="plot.config.tableMode"
                                                              :label="'Multiple'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-title class="primary white--text subheading">
                                            {{'Fields'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(field,fieldIndex) in plot.config.fields">
                                                    <v-layout row wrap>
                                                        <v-flex xs3>
                                                            <v-text-field :label="'Label'|translate"  v-model="field.label"></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs3 class="pl-2">
                                                            <sensor-selector label="Sensor" v-model="field.sensor"></sensor-selector>
                                                        </v-flex>
                                                        <v-flex xs3 class="pl-2">
                                                            <v-text-field :label="'Hint'|translate"  v-model="field.hint" clearable></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs1 class="pl-2">
                                                            <v-switch color="success"
                                                                      v-model="field.required"
                                                                      :label="'Required'|translate"
                                                            ></v-switch>
                                                        </v-flex>
                                                        <v-flex xs2>
                                                            <v-layout row>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="primary" @click="plot.config.fields.splice(fieldIndex,1)">
                                                                <v-icon class="mr-2" small>
                                                                    fa-trash
                                                                </v-icon>
                                                                {{'Delete'|translate}}
                                                            </v-btn>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider></v-divider>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="plot.config.fields.push({label:'Label',hint:null,sensor:null,required:false})" class="mr-2">{{'Add Field'|translate}}</v-btn>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='parameter-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Parameters'|translate}} <v-spacer></v-spacer><v-btn icon @click="plot.config.fields.push({name:'parameter',min:0,max:10, step:1, label:'Parameter', defaultValue:1})" class="mr-2"><v-icon>fa-plus</v-icon></v-btn>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(field,fieldIndex) in plot.config.fields">
                                                    <v-layout row wrap>
                                                        <v-flex xs5>
                                                            <v-text-field :label="'Name'|translate"  v-model="field.name"></v-text-field>
                                                            <v-text-field :label="'Label'|translate"  v-model="field.label"></v-text-field>
                                                            <v-text-field :label="'Default Value'|translate"  v-model.number="field.defaultValue"></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs5 class="pl-3">
                                                            <v-text-field :label="'Min'|translate"  v-model.number="field.min"></v-text-field>
                                                            <v-text-field :label="'Max'|translate"  v-model.number="field.max"></v-text-field>
                                                            <v-text-field :label="'Step'|translate"  v-model.number="field.step"></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs2>
                                                            <v-layout row>
                                                            <v-spacer></v-spacer>
                                                            <v-btn color="primary" @click="plot.config.fields.splice(fieldIndex,1)">
                                                                <v-icon class="mr-2" small>
                                                                    fa-trash
                                                                </v-icon>
                                                                {{'Delete'|translate}}
                                                            </v-btn>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider></v-divider>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="applyFieldsToParam(plot.config.fields); plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>

                                <v-dialog v-if="plot.type==='heatmap-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Heatmap'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs6>
                                                    <v-text-field :label="'Image URL'|translate"  v-model="plot.config.imageUrl"></v-text-field>
                                                    <v-text-field :label="'Height'|translate"  v-model.number="plot.config.height"></v-text-field>
                                                    <v-text-field :label="'Width'|translate"  v-model.number="plot.config.width"></v-text-field>
                                                    <v-text-field :label="'Radius'|translate"  v-model.number="plot.config.options.radius"></v-text-field>
                                                    <v-text-field :label="'Blur'|translate"  v-model.number="plot.config.options.blur"></v-text-field>
                                                    <v-text-field :label="'Max opacity'|translate"  v-model.number="plot.config.options.maxOpacity"></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.player"
                                                              :label="'Player'|translate"
                                                    ></v-switch>

                                                </v-flex>
                                                <v-flex xs6 class="pl-3">
                                                    <v-text-field :label="'Min'|translate"  v-model.number="plot.config.min"></v-text-field>
                                                    <v-text-field :label="'Max'|translate"  v-model.number="plot.config.max"></v-text-field>
                                                    <v-select
                                                            :items="aggFreq"
                                                            :label="'Agg Frequency'|translate"
                                                            v-model="plot.config.agg"
                                                            clearable
                                                    ></v-select>
                                                    <v-select
                                                            :items="aggOpp"
                                                            :label="'Agg Operation'|translate"
                                                            v-model="plot.config.aggOpp"
                                                            clearable
                                                    ></v-select>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.onOnly"
                                                              :label="'On Only'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-title class="primary white--text subheading">
                                            {{'Points'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(point,pointIndex) in plot.config.points">
                                                    <v-layout row wrap>
                                                        <v-flex xs5>
                                                            <v-text-field :label="'X'|translate"  v-model.number="point.x"></v-text-field>
                                                            <v-text-field :label="'Y'|translate"  v-model.number="point.y"></v-text-field>

                                                        </v-flex>
                                                        <v-flex xs5 class="pl-3">
                                                            <v-text-field :label="'Equipment'|translate"  v-model="point.equipment_name" readonly=""></v-text-field>
                                                            <v-text-field :label="'Sensor'|translate"  v-model="point.name" readonly=""></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs2>
                                                            <v-layout row>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="primary" @click="plot.config.points.splice(pointIndex,1)">
                                                                    <v-icon class="mr-2" small>
                                                                        fa-trash
                                                                    </v-icon>
                                                                    {{'Delete'|translate}}
                                                                </v-btn>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider></v-divider>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="pointPickerDiag=true" class="mr-2">{{'Add Points'|translate}} </v-btn>
                                            <point-picker-dialog v-model="pointPickerDiag" :callback="(points)=>{plot.config.points.push(...points)}"></point-picker-dialog>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='forge-viewer-heatmap-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'3D Heatmap'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs6>
                                                    <v-text-field :label="'A360 Embed URL'|translate"  v-model="plot.config.url"></v-text-field>
                                                    <v-text-field :label="'Height'|translate"  v-model.number="plot.config.height"></v-text-field>
                                                    <v-text-field :label="'Surface Item ID'|translate"  v-model.number="plot.config.surfaceId" clearable></v-text-field>
                                                    <v-text-field :label="'Floor Name'|translate"  v-model="plot.config.floorName" clearable></v-text-field>
                                                </v-flex>
                                                <v-flex xs6 class="pl-3">
                                                    <v-select
                                                            :items="aggFreq"
                                                            :label="'Agg Frequency'|translate"
                                                            v-model="plot.config.agg"
                                                            clearable
                                                    ></v-select>
                                                    <v-select
                                                            :items="aggOpp"
                                                            :label="'Agg Operation'|translate"
                                                            v-model="plot.config.aggOpp"
                                                            clearable
                                                    ></v-select>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.onOnly"
                                                              :label="'On Only'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-title class="primary white--text subheading">
                                            {{'Points'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(point,pointIndex) in plot.config.points">
                                                    <v-layout row wrap>
                                                        <v-flex xs5>
                                                            <v-text-field :label="'X'|translate"  v-model.number="point.x"></v-text-field>
                                                            <v-text-field :label="'Y'|translate"  v-model.number="point.y"></v-text-field>
                                                            <v-text-field :label="'Z'|translate"  v-model.number="point.z"></v-text-field>

                                                        </v-flex>
                                                        <v-flex xs5 class="pl-3">
                                                            <v-text-field :label="'Equipment'|translate"  v-model="point.equipment_name" readonly=""></v-text-field>
                                                            <v-text-field :label="'Sensor'|translate"  v-model="point.name" readonly=""></v-text-field>
                                                        </v-flex>
                                                        <v-flex xs2>
                                                            <v-layout row>
                                                                <v-spacer></v-spacer>
                                                                <v-btn color="primary" @click="plot.config.points.splice(pointIndex,1)">
                                                                    <v-icon class="mr-2" small>
                                                                        fa-trash
                                                                    </v-icon>
                                                                    {{'Delete'|translate}}
                                                                </v-btn>
                                                            </v-layout>
                                                        </v-flex>
                                                    </v-layout>
                                                    <v-divider></v-divider>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="pointPickerDiag2=true" class="mr-2">{{'Add Points'|translate}} </v-btn>
                                            <point-picker-dialog v-model="pointPickerDiag2" :callback="(points)=>{plot.config.points.push(...points)}"></point-picker-dialog>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='sensor-calibration-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1400" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Sensor Calibration'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-text-field :label="'Title'|translate"  v-model="plot.config.title"></v-text-field>
                                        </v-card-text>
                                        <v-card-title class="primary white--text subheading">
                                            {{'Config'|translate}} <v-spacer></v-spacer><v-btn icon @click="plot.config.conf.push({x:[{equip_sensor:null,weight:null,weight_number:1}],y:[{equip_sensor:null,weight:null,weight_number:1}]})" class="mr-2"><v-icon>fa-plus</v-icon></v-btn>
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12 v-for="(conf,confIndex) in plot.config.conf">
                                                    <v-card elevation="2" class="mb-3">
                                                    <v-card-title class="primary white--text subheading">
                                                        <v-btn @click="conf.x.push({equip_sensor:null,weight:null,weight_number:1})">
                                                            Add X
                                                        </v-btn>
                                                        <v-spacer></v-spacer>
                                                        <v-btn @click="conf.y.push({equip_sensor:null,weight:null,weight_number:1})" class="mr-2">
                                                            Add Y
                                                        </v-btn>
                                                        <v-btn icon @click="plot.config.conf.splice(confIndex,1)">
                                                            <v-icon>
                                                                fa-trash
                                                            </v-icon>
                                                        </v-btn>
                                                    </v-card-title>
                                                    <v-card-text>
                                                        <v-layout row wrap>
                                                            <v-flex xs6 class="pr-2" style="border-right: 2px solid #DDDDDD;">
                                                                <v-layout row wrap>
                                                                    <v-flex xs12
                                                                            v-for="(point,pointIndex) in conf.x">
                                                                        <v-layout row wrap>
                                                                            <v-flex xs3>
                                                                                <v-text-field
                                                                                    :label="'Weight number'|translate"
                                                                                    v-model.number="point.weight_number"></v-text-field>
                                                                            </v-flex>
                                                                            <v-flex xs4 class="pl-3">
                                                                                <sensor-selector
                                                                                    :label="'Weight'|translate"
                                                                                    v-model="point.weight"
                                                                                    clearable
                                                                                    readonly=""></sensor-selector>
                                                                            </v-flex>
                                                                            <v-flex xs4 class="pl-3">
                                                                                <sensor-selector
                                                                                    :label="'Sensor'|translate"
                                                                                    v-model="point.equip_sensor"
                                                                                    readonly=""></sensor-selector>
                                                                            </v-flex>
                                                                            <v-flex xs1>
                                                                                <v-layout row>
                                                                                    <v-spacer></v-spacer>
                                                                                    <v-btn icon class="mt-3"
                                                                                           @click="conf.x.splice(pointIndex,1)">
                                                                                        <v-icon small>
                                                                                            fa-trash
                                                                                        </v-icon>
                                                                                    </v-btn>
                                                                                </v-layout>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider></v-divider>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>
                                                            <v-flex xs6 class="pl-2">
                                                                <v-layout row wrap>
                                                                    <v-flex xs12
                                                                            v-for="(point,pointIndex) in conf.y">
                                                                        <v-layout row wrap>
                                                                            <v-flex xs3>
                                                                                <v-text-field
                                                                                    :label="'Weight number'|translate"
                                                                                    v-model.number="point.weight_number"></v-text-field>
                                                                            </v-flex>
                                                                            <v-flex xs4 class="pl-3">
                                                                                <sensor-selector
                                                                                    :label="'Weight'|translate"
                                                                                    v-model="point.weight"
                                                                                    clearable
                                                                                    readonly=""></sensor-selector>
                                                                            </v-flex>
                                                                            <v-flex xs4 class="pl-3">
                                                                                <sensor-selector
                                                                                    :label="'Sensor'|translate"
                                                                                    v-model="point.equip_sensor"
                                                                                    readonly=""></sensor-selector>
                                                                            </v-flex>
                                                                            <v-flex xs1>
                                                                                <v-layout row>
                                                                                    <v-spacer></v-spacer>
                                                                                    <v-btn icon class="mt-3"
                                                                                           @click="conf.y.splice(pointIndex,1)">
                                                                                        <v-icon small>
                                                                                            fa-trash
                                                                                        </v-icon>
                                                                                    </v-btn>
                                                                                </v-layout>
                                                                            </v-flex>
                                                                        </v-layout>
                                                                        <v-divider></v-divider>
                                                                    </v-flex>
                                                                </v-layout>
                                                            </v-flex>

                                                        </v-layout>
                                                    </v-card-text>
                                                    </v-card>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='optimization-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Optimization'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs6>
                                                    <v-text-field :label="'Title'|translate" v-model="plot.config.title"></v-text-field>
                                                    <v-text-field :label="'Start Date'|translate" type="date"  v-model="plot.config.startDate" clearable></v-text-field>
                                                    <v-text-field :label="'End Date'|translate" type="date"  v-model="plot.config.endDate" clearable></v-text-field>
                                                    <v-text-field :label="'Cutoff Date'|translate" type="date"  v-model="plot.config.cutOff" clearable></v-text-field>
                                                    <v-select
                                                            :items="aggFreq"
                                                            :label="'Agg Frequency'|translate"
                                                            v-model="plot.config.aggFrequency"
                                                            clearable
                                                    ></v-select>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.useSwitch"
                                                              :label="'Use Switch'|translate"
                                                    ></v-switch>
                                                    <sensor-selector :label="'Switch Sensor'|translate" v-if="plot.config.useSwitch"  v-model="plot.config.switchSensor"></sensor-selector>
                                                    <v-select
                                                            :items="['linear','custom']"
                                                            :label="'Interpolation'|translate"
                                                            v-model="plot.config.interpolation"
                                                    ></v-select>
                                                    <v-text-field :label="'Custom Interpolation Function'|translate" v-if="plot.config.interpolation==='custom'"  v-model="plot.config.customInterpolation" clearable></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.hideKpi"
                                                              :label="'Hide KPI'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                                <v-flex xs6 class="pl-3">
                                                    <v-text-field :label="'Min X'|translate"  v-model.number="plot.config.minTemp"></v-text-field>
                                                    <v-text-field :label="'Max X'|translate"  v-model.number="plot.config.maxTemp"></v-text-field>
                                                    <v-text-field :label="'Min Power'|translate"  v-model.number="plot.config.minPower"></v-text-field>
                                                    <v-text-field :label="'Max Power'|translate"  v-model.number="plot.config.maxPower"></v-text-field>
                                                    <sensor-selector :label="'Exact Power Sensor'|translate"  v-model="plot.config.exactPowerSensor" clearable></sensor-selector>
                                                    <v-text-field :label="'Summed Power Sensor'|translate" v-model="plot.config.powerSensor" v-if="!plot.config.exactPowerSensor"></v-text-field>
                                                    <sensor-selector :label="'X Sensor'|translate"  v-model="plot.config.weatherSensor"></sensor-selector>
                                                    <v-text-field :label="'X Title'|translate" v-model="plot.config.weatherTitle"></v-text-field>
                                                    <v-select
                                                            :items="aggOpp"
                                                            :label="'X Agg Operation'|translate"
                                                            v-model="plot.config.weatherAgg"
                                                    ></v-select>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.ecMode"
                                                              :label="'EC Mode'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='flexible-optimization-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Custom Optimization'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs6>
                                                    <v-text-field :label="'Title'|translate" v-model="plot.config.title"></v-text-field>
                                                    <v-text-field :label="'Start Date'|translate" type="date"  v-model="plot.config.startDate" clearable></v-text-field>
                                                    <v-text-field :label="'End Date'|translate" type="date"  v-model="plot.config.endDate" clearable></v-text-field>
                                                    <v-text-field :label="'Cutoff Date'|translate" type="date"  v-model="plot.config.cutOff" clearable></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.useSwitch"
                                                              :label="'Use Switch'|translate"
                                                    ></v-switch>
                                                    <v-text-field :label="'Switch Series'|translate" v-if="plot.config.useSwitch"  v-model="plot.config.switchSensor"></v-text-field>
                                                    <v-select
                                                            :items="['linear','custom']"
                                                            :label="'Interpolation'|translate"
                                                            v-model="plot.config.interpolation"
                                                    ></v-select>
                                                    <v-text-field :label="'Custom Interpolation Function'|translate" v-if="plot.config.interpolation==='custom'"  v-model="plot.config.customInterpolation" clearable></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.hideKpi"
                                                              :label="'Hide KPI'|translate"
                                                    ></v-switch>
                                                    <v-switch color="success" class="ml-2"
                                                              v-if="!plot.config.hideKpi"
                                                              v-model="plot.config.showCalc"
                                                              :label="'Show Baseline Calculation'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                                <v-flex xs6 class="pl-3">
                                                    <v-text-field :label="'Min X'|translate"  v-model.number="plot.config.minTemp"></v-text-field>
                                                    <v-text-field :label="'Max X'|translate"  v-model.number="plot.config.maxTemp"></v-text-field>
                                                    <v-text-field :label="'Power Series'|translate" v-model="plot.config.powerSensor"></v-text-field>
                                                    <v-text-field :label="'X Series'|translate"  v-model="plot.config.weatherSensor"></v-text-field>
                                                    <v-text-field :label="'X Title'|translate" v-model="plot.config.weatherTitle"></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.ecMode"
                                                              :label="'EC Mode'|translate"
                                                    ></v-switch>
                                                    <v-text-field :label="'EC Resampling Factor'|translate" v-model.number="plot.config.resamplingFactor" clearable></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.showNegativeMonthly"
                                                              :label="'Monthly axis unlock'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="cbInternalDiag2=true" v-if="!plot.config.data3query" class="mr-2">{{'Add Data Query'|translate}} </v-btn>
                                            <v-btn @click="cbInternalDiag2=true" v-if="plot.config.data3query" class="mr-2">{{'Edit Data Query'|translate}} </v-btn>
                                            <v-dialog v-model="cbInternalDiag2" fullscreen persistent>
                                                <chart-builder v-if="cbInternalDiag2" headless-mode :callback="(cfg)=>{plot.config.data3query=cfg}" :initial-value="plot.config.data3query" :default-range="range" v-on:close="cbInternalDiag2=false" :parameters="parameters" :equipment-relationships="equipmentRelationships"></chart-builder>
                                            </v-dialog>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='cop-savings-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'COP Improvement'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs6>
                                                    <v-text-field :label="'Title'|translate" v-model="plot.config.title"></v-text-field>
                                                    <v-text-field :label="'Start Date'|translate" type="date"  v-model="plot.config.startDate" clearable></v-text-field>
                                                    <v-text-field :label="'End Date'|translate" type="date"  v-model="plot.config.endDate" clearable></v-text-field>
                                                    <v-text-field :label="'Cutoff Date'|translate" type="date"  v-model="plot.config.cutOff" clearable></v-text-field>
                                                    <v-select
                                                            :items="aggFreq"
                                                            :label="'Agg Frequency'|translate"
                                                            v-model="plot.config.aggFrequency"
                                                            clearable
                                                    ></v-select>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.useSwitch"
                                                              :label="'Use Switch'|translate"
                                                    ></v-switch>
                                                    <sensor-selector :label="'Switch Sensor'|translate" v-if="plot.config.useSwitch"  v-model="plot.config.switchSensor"></sensor-selector>
                                                    <v-select
                                                            :items="['linear','custom']"
                                                            :label="'Interpolation'|translate"
                                                            v-model="plot.config.interpolation"
                                                    ></v-select>
                                                    <v-text-field :label="'Custom Interpolation Function'|translate" v-if="plot.config.interpolation==='custom'"  v-model="plot.config.customInterpolation" clearable></v-text-field>
                                                  <v-switch color="success" class="ml-2"
                                                            v-model="plot.config.hideKpi"
                                                            :label="'Hide KPI'|translate"
                                                  ></v-switch><v-switch color="success" class="ml-2" v-if="!plot.config.hideKpi"
                                                            v-model="plot.config.showMeanCop"
                                                            :label="'Show mean COP'|translate"
                                                  ></v-switch>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.ecMode"
                                                              :label="'EC Mode'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                                <v-flex xs6 class="pl-3">
                                                    <v-text-field :label="'Min Cooling Load'|translate"  v-model.number="plot.config.minCoolingLoad"></v-text-field>
                                                    <v-text-field :label="'Max Cooling Load'|translate"  v-model.number="plot.config.maxCoolingLoad"></v-text-field>
                                                    <v-text-field :label="'Min Power'|translate"  v-model.number="plot.config.minPower"></v-text-field>
                                                    <v-text-field :label="'Max Power'|translate"  v-model.number="plot.config.maxPower"></v-text-field>
                                                    <sensor-selector :label="'Power Sensor'|translate"  v-model="plot.config.powerSensor"></sensor-selector>
                                                    <sensor-selector :label="'Cooling Load Sensor'|translate"  v-model="plot.config.coolingLoadSensor"></sensor-selector>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.useFilter"
                                                              :label="'Use Filter'|translate"
                                                    ></v-switch>
                                                    <sensor-selector v-if="plot.config.useFilter" :label="'Filter Sensor'|translate"  v-model="plot.config.filterSensor"></sensor-selector>
                                                    <v-text-field v-if="plot.config.useFilter" :label="'Min Filter'|translate"  v-model.number="plot.config.minFilter"></v-text-field>
                                                    <v-text-field v-if="plot.config.useFilter" :label="'Max Filter'|translate"  v-model.number="plot.config.maxFilter"></v-text-field>

                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='flexible-cop-savings-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Custom COP Improvement'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs6>
                                                    <v-text-field :label="'Title'|translate" v-model="plot.config.title"></v-text-field>
                                                    <v-text-field :label="'Start Date'|translate" type="date"  v-model="plot.config.startDate" clearable></v-text-field>
                                                    <v-text-field :label="'End Date'|translate" type="date"  v-model="plot.config.endDate" clearable></v-text-field>
                                                    <v-text-field :label="'Cutoff Date'|translate" type="date"  v-model="plot.config.cutOff" clearable></v-text-field>
                                                  <v-switch color="success" class="ml-2"
                                                            v-model="plot.config.hideKpi"
                                                            :label="'Hide KPI'|translate"
                                                  ></v-switch><v-switch color="success" class="ml-2" v-if="!plot.config.hideKpi"
                                                            v-model="plot.config.showMeanCop"
                                                            :label="'Show mean COP'|translate"
                                                  ></v-switch>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.ecMode"
                                                              :label="'EC Mode'|translate"
                                                    ></v-switch>
                                                    <v-text-field :label="'EC Resampling Factor'|translate" v-model.number="plot.config.resamplingFactor" clearable></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.showNegativeMonthly"
                                                              :label="'Monthly axis unlock'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                                <v-flex xs6 class="pl-3">
                                                    <v-text-field :label="'Power Series'|translate" v-model="plot.config.powerSensor"></v-text-field>
                                                    <v-text-field :label="'Cooling Load Series'|translate" v-model="plot.config.coolingLoadSensor"></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.useSwitch"
                                                              :label="'Use Switch'|translate"
                                                    ></v-switch>
                                                    <v-text-field :label="'Switch Series'|translate" v-if="plot.config.useSwitch"  v-model="plot.config.switchSensor"></v-text-field>
                                                    <v-select
                                                        :items="['linear','custom']"
                                                        :label="'Interpolation'|translate"
                                                        v-model="plot.config.interpolation"
                                                    ></v-select>
                                                    <v-text-field :label="'Custom Interpolation Function'|translate" v-if="plot.config.interpolation==='custom'"  v-model="plot.config.customInterpolation" clearable></v-text-field>
                                                    <v-select
                                                        :items="['linear','loess','custom','manual']"
                                                        :label="'After Optimization Interpolation'|translate"
                                                        v-model="plot.config.postInterpolation"
                                                        clearable
                                                    ></v-select>
                                                    <v-text-field  v-if="plot.config.postInterpolation==='loess'" :label="'Span'|translate"  v-model.number="plot.config.span"></v-text-field>
                                                    <v-text-field  v-if="plot.config.postInterpolation==='loess'" :label="'Band'|translate"  v-model.number="plot.config.band"></v-text-field>
                                                    <v-text-field  v-if="plot.config.postInterpolation==='loess'" :label="'Degree'|translate"  v-model.number="plot.config.degree"></v-text-field>
                                                    <v-switch color="success" class="ml-2" v-if="plot.config.postInterpolation==='loess'"
                                                              v-model="plot.config.showCopyBtn"
                                                              :label="'Show interpolation data copy button'|translate"
                                                    ></v-switch>
                                                    <v-text-field :label="'Custom After Optimization Interpolation Function'|translate" v-if="plot.config.postInterpolation==='custom'"  v-model="plot.config.customPostInterpolation" clearable></v-text-field>
                                                    <v-text-field :label="'Custom After Optimization Data JSON'|translate" v-if="plot.config.postInterpolation==='manual'"  v-model="plot.config.postInterpolationPoints" clearable></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="cbInternalDiag3=true" v-if="!plot.config.data3query" class="mr-2">{{'Add Data Query'|translate}} </v-btn>
                                            <v-btn @click="cbInternalDiag3=true" v-if="plot.config.data3query" class="mr-2">{{'Edit Data Query'|translate}} </v-btn>
                                            <v-dialog v-model="cbInternalDiag3" fullscreen persistent>
                                                <chart-builder v-if="cbInternalDiag3" headless-mode :callback="(cfg)=>{plot.config.data3query=cfg}" :initial-value="plot.config.data3query" :default-range="range" v-on:close="cbInternalDiag3=false" :parameters="parameters" :equipment-relationships="equipmentRelationships"></chart-builder>
                                            </v-dialog>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='bms-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'BMS'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-text-field :label="'Title'|translate" v-model="plot.config.title"></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.latestOnly"
                                                              :label="'Latest Only'|translate"
                                                    ></v-switch>
                                                    <label>SVG</label>
                                                    <editor v-model="plot.config.svg" @init="svgEditorInit" lang="svg" theme="twilight" width="100%" height="500"></editor>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='solar-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Solar'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-text-field :label="'Height'|translate" v-model.number="plot.config.height"></v-text-field>
                                                    <v-text-field :label="'Latitude'|translate" v-model.number="plot.config.lat"></v-text-field>
                                                    <v-text-field :label="'Longitude'|translate" v-model.number="plot.config.lon"></v-text-field>
                                                    <v-text-field :label="'Main light intensity'|translate" v-model.number="plot.config.mainIntensity"></v-text-field>
                                                    <v-text-field :label="'Ambient light intensity'|translate" v-model.number="plot.config.ambientIntensity"></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.showClock"
                                                              :label="'Show Clock'|translate"
                                                    ></v-switch>
                                                    <label>Geo JSON</label>
                                                    <editor v-model="plot.config.featuresJson" @init="jsonEditorInit" lang="json" theme="twilight" width="100%" height="500"></editor>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='custom-ec-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1800" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Custom EC'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs2>
                                                    <v-text-field :label="'Height'|translate"  v-model.number="plot.config.height"></v-text-field>

                                                </v-flex>
                                                <v-flex xs2>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.enableMerge"
                                                              :label="'Enable Merge'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                                <v-flex xs2>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.animationMode"
                                                              :label="'Animation'|translate"
                                                    ></v-switch>
                                                    <v-text-field v-if="plot.config.animationMode" :label="'Animation timer (seconds)'|translate"  v-model.number="plot.config.timer"></v-text-field>
                                                </v-flex>
                                                <v-flex xs2>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.noReload"
                                                              :label="'No reload on refresh'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                                <v-flex xs2>
                                                    <v-text-field :label="'Vertical Offset'|translate" v-model.number="plot.config.verticalOffset" clearable></v-text-field>
                                                </v-flex>
                                                <v-flex xs2>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.startHiddenEquip"
                                                              :label="'Start Hidden'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                            </v-layout>
                                            <v-layout row wrap>
                                                <v-flex xs9>
                                                    <label>Processor function</label>
                                                    <v-layout row wrap>
                                                        <v-btn v-for="ecp in availableECPresents" @click="applyPresetToEC(plot,ecp)">
                                                            <v-icon class="mr-2">{{ecp.icon}}</v-icon>
                                                            <span>{{ecp.name}}</span>
                                                        </v-btn>
                                                    </v-layout>

                                                    <editor v-model="plot.config.processorFunction" @init="jsEditorInit" lang="javascript" theme="twilight" width="100%" height="600"></editor>
                                                </v-flex>
                                                <v-flex xs3 class="pl-3" v-if="plot.config.settings">
                                                    <label>Settings</label>
                                                    <v-select
                                                        :label="'Colorway'|translate" v-model="plot.config.settings.colorway"
                                                        :items="availableColorways"
                                                    ></v-select>
                                                    <div v-if="plot.config.configInterface">
                                                        <div v-for="arg in plot.config.configInterface">
                                                            <v-text-field v-if="arg.type==='string'" :label="arg.label|translate" v-model="plot.config.settings[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []" :clearable="!arg.required"></v-text-field>
                                                            <v-text-field v-if="arg.type==='color'" :label="arg.label|translate" v-model="plot.config.settings[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []" :clearable="!arg.required">
                                                                <template v-slot:prepend>
                                                                    <v-icon v-show="plot.config.settings[arg.name]" v-bind:style="{ color: plot.config.settings[arg.name] }">fa-tint</v-icon>
                                                                </template>
                                                            </v-text-field>
                                                            <v-text-field v-if="arg.type==='number'" type="number" :label="arg.label|translate" v-model.number="plot.config.settings[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []" :clearable="!arg.required"></v-text-field>
                                                            <equipment-selector v-if="arg.type==='equipment_name'" :label="arg.label|translate" v-model="plot.config.settings[arg.name]" :clearable="!arg.required"></equipment-selector>
                                                            <v-text-field v-if="arg.type==='date'" type="date" :label="arg.label|translate" v-model="plot.config.settings[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []" :clearable="!arg.required"></v-text-field>
                                                            <v-switch color="success" class="ml-2" v-if="arg.type==='boolean'" :label="arg.label|translate" v-model="plot.config.settings[arg.name]"></v-switch>
                                                            <sensor-selector v-if="arg.type==='sensor_selector'" :label="arg.label|translate" v-model="plot.config.settings[arg.name]" :clearable="!arg.required"></sensor-selector>
                                                            <graphic-selector v-if="arg.type==='graphic_selector'" :label="arg.label|translate" v-model="plot.config.settings[arg.name]" :clearable="!arg.required"></graphic-selector>
                                                            <autotuner-selector v-if="arg.type==='autotuner_selector'" :label="arg.label|translate" v-model="plot.config.settings[arg.name]" :clearable="!arg.required"></autotuner-selector>
                                                            <v-select v-if="arg.type==='selector'" :label="arg.label|translate" v-model="plot.config.settings[arg.name]" :items="arg.items" :clearable="!arg.required" :multiple="arg.multiple"></v-select>
                                                            <v-select
                                                                v-if="arg.type==='agg_freq'" :label="arg.label|translate" v-model="plot.config.settings[arg.name]"
                                                                :items="aggFreq"
                                                                :clearable="!arg.required"
                                                            ></v-select>
                                                            <v-radio-group v-if="arg.type==='radio'" :label="arg.label|translate" v-model="plot.config.settings[arg.name]" :mandatory="arg.required">
                                                                <v-radio v-for="item in arg.items" :label="item.label|translate" :value="item.value" :color="item.color"></v-radio>
                                                            </v-radio-group>
                                                        </div>
                                                    </div>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="cbInternalDiag4=true" v-if="!plot.config.data3query" class="mr-2">{{'Add Data Query'|translate}} </v-btn>
                                            <v-btn @click="cbInternalDiag4=true" v-if="plot.config.data3query" class="mr-2">{{'Edit Data Query'|translate}} </v-btn>
                                            <v-btn @click="plot.config.data3query=null" v-if="plot.config.data3query" class="mr-2">{{'Delete Data Query'|translate}} </v-btn>
                                            <v-dialog v-model="cbInternalDiag4" fullscreen persistent>
                                                <chart-builder v-if="cbInternalDiag4" headless-mode :callback="(cfg)=>{plot.config.data3query=cfg}" :initial-value="plot.config.data3query" :default-range="range" v-on:close="cbInternalDiag4=false" :parameters="parameters" :equipment-relationships="equipmentRelationships"></chart-builder>
                                            </v-dialog>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='data-export-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="800" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Data Export'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-text-field :label="'Button Title'|translate"  v-model="plot.config.title"></v-text-field>
                                                    <v-text-field :label="'File Name'|translate"  v-model="plot.config.fileName"></v-text-field>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.includeRangeInName"
                                                              :label="'Include date range in file name'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="cbInternalDiag6=true" v-if="!plot.config.data3query" class="mr-2">{{'Add Data Query'|translate}} </v-btn>
                                            <v-btn @click="cbInternalDiag6=true" v-if="plot.config.data3query" class="mr-2">{{'Edit Data Query'|translate}} </v-btn>
                                            <v-btn @click="plot.config.data3query=null" v-if="plot.config.data3query" class="mr-2">{{'Delete Data Query'|translate}} </v-btn>
                                            <v-dialog v-model="cbInternalDiag6" fullscreen persistent>
                                                <chart-builder v-if="cbInternalDiag6" headless-mode :callback="(cfg)=>{plot.config.data3query=cfg}" :initial-value="plot.config.data3query" :default-range="range" v-on:close="cbInternalDiag6=false" :parameters="parameters" :equipment-relationships="equipmentRelationships"></chart-builder>
                                            </v-dialog>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='optimization-viz-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="800" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Optimization Vizualization'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <v-text-field :label="'Title'|translate"  v-model="plot.config.title"></v-text-field>
                                                    <v-text-field :label="'Target field'|translate"  v-model="plot.config.target"></v-text-field>
                                                    <v-text-field :label="'Height'|translate"  v-model.number="plot.config.height"></v-text-field>
                                                    <v-text-field :label="'Increment'|translate"  v-model.number="plot.config.increment"></v-text-field>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="cbInternalDiag7=true" v-if="!plot.config.data3query" class="mr-2">{{'Add Data Query'|translate}} </v-btn>
                                            <v-btn @click="cbInternalDiag7=true" v-if="plot.config.data3query" class="mr-2">{{'Edit Data Query'|translate}} </v-btn>
                                            <v-btn @click="plot.config.data3query=null" v-if="plot.config.data3query" class="mr-2">{{'Delete Data Query'|translate}} </v-btn>
                                            <v-dialog v-model="cbInternalDiag7" fullscreen persistent>
                                                <chart-builder v-if="cbInternalDiag7" headless-mode :callback="(cfg)=>{plot.config.data3query=cfg}" :initial-value="plot.config.data3query" :default-range="range" v-on:close="cbInternalDiag7=false" :parameters="parameters" :equipment-relationships="equipmentRelationships"></chart-builder>
                                            </v-dialog>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='svg-widget'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'Custom'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs5>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.includeIssues"
                                                              :label="'Include issues'|translate"
                                                    ></v-switch>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.includeMaintenance"
                                                              :label="'Include maintenance Records'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                                <v-flex xs5>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.includeConfig"
                                                              :label="'Include config'|translate"
                                                    ></v-switch>
                                                    <v-switch color="success" class="ml-2"
                                                              v-model="plot.config.noReload"
                                                              :label="'No reload on refresh'|translate"
                                                    ></v-switch>
                                                </v-flex>
                                                <v-flex xs2>
                                                    <v-text-field :label="'Vertical Offset'|translate" v-model.number="plot.config.verticalOffset" clearable></v-text-field>
                                                </v-flex>
                                                <v-flex xs12>
                                                    <label>HTML</label>
                                                    <v-layout row wrap>
                                                        <v-btn v-for="cp in availableCustomPresents" @click="plot.config.svg=cp.baseTPL">
                                                            <v-icon class="mr-2">{{cp.icon}}</v-icon>
                                                            <span>{{cp.name}}</span>
                                                        </v-btn>
                                                    </v-layout>
                                                    <editor v-model="plot.config.svg" @init="htmlEditorInit" lang="html" theme="twilight" width="100%" height="500"></editor>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="cbInternalDiag=true" v-if="!plot.config.data3query" class="mr-2">{{'Add Data Query'|translate}} </v-btn>
                                            <v-btn @click="cbInternalDiag=true" v-if="plot.config.data3query" class="mr-2">{{'Edit Data Query'|translate}} </v-btn>
                                            <v-dialog v-model="cbInternalDiag" fullscreen persistent>
                                                <chart-builder v-if="cbInternalDiag" headless-mode :callback="(cfg)=>{plot.config.data3query=cfg}" :initial-value="plot.config.data3query" :default-range="range" v-on:close="cbInternalDiag=false" :parameters="parameters" :equipment-relationships="equipmentRelationships"></chart-builder>
                                            </v-dialog>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                                <v-dialog v-if="plot.type==='code'&&plot.editDialog" v-model="plot.editDialog" max-width="1200" persistent>
                                    <v-card>
                                        <v-card-title class="primary white--text title">
                                            {{'HTML Code'|translate}}
                                        </v-card-title>
                                        <v-card-text>
                                            <v-layout row wrap>
                                                <v-flex xs12>
                                                    <editor v-model="plot.config.html" @init="htmlEditorInit" lang="html" theme="twilight" width="100%" height="500"></editor>
                                                </v-flex>
                                            </v-layout>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer></v-spacer>
                                            <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-dialog>
                              <v-dialog v-if="plot.editDialog&&availableWidgets[plot.type]&&availableWidgets[plot.type].configInterface" v-model="plot.editDialog" max-width="600" persistent>
                                <v-card>
                                  <v-card-title class="primary white--text title">
                                    {{ availableWidgets[plot.type].configInterface.title }}
                                  </v-card-title>
                                  <v-card-text>
                                    <v-layout row wrap>
                                        <v-flex xs12 v-if="availableWidgets[plot.type].configInterface.description">
                                            <div v-html="availableWidgets[plot.type].configInterface.description"></div>
                                        </v-flex>
                                      <v-flex xs12 v-for="arg in availableWidgets[plot.type].configInterface.args" v-if="!arg.conditionField||plot.config[arg.conditionField]==arg.conditionValue">
                                        <v-text-field v-if="arg.type==='string'" :label="arg.label|translate" v-model="plot.config[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []" :clearable="!arg.required"></v-text-field>
                                        <v-text-field v-if="arg.type==='color'" :label="arg.label|translate" v-model="plot.config[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []" :clearable="!arg.required">
                                            <template v-slot:prepend>
                                                <v-icon v-show="plot.config[arg.name]" v-bind:style="{ color: plot.config[arg.name] }">fa-tint</v-icon>
                                            </template>
                                        </v-text-field>
                                        <v-text-field v-if="arg.type==='number'" type="number" :label="arg.label|translate" v-model.number="plot.config[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []" :clearable="!arg.required"></v-text-field>
                                        <equipment-selector v-if="arg.type==='equipment_name'" :label="arg.label|translate" v-model="plot.config[arg.name]" :clearable="!arg.required"></equipment-selector>
                                        <v-text-field v-if="arg.type==='date'" type="date" :label="arg.label|translate" v-model="plot.config[arg.name]" :rules="arg.required ? [(v) => !!v || 'This field is required'] : []" :clearable="!arg.required"></v-text-field>
                                        <v-switch color="success" class="ml-2" v-if="arg.type==='boolean'" :label="arg.label|translate" v-model="plot.config[arg.name]"></v-switch>
                                        <sensor-selector v-if="arg.type==='sensor_selector'" :label="arg.label|translate" v-model="plot.config[arg.name]" :clearable="!arg.required"></sensor-selector>
                                        <graphic-selector v-if="arg.type==='graphic_selector'" :label="arg.label|translate" v-model="plot.config[arg.name]" :clearable="!arg.required"></graphic-selector>
                                        <autotuner-selector v-if="arg.type==='autotuner_selector'" :label="arg.label|translate" v-model="plot.config[arg.name]" :clearable="!arg.required"></autotuner-selector>
                                        <v-select v-if="arg.type==='selector'" :label="arg.label|translate" v-model="plot.config[arg.name]" :items="arg.items" :clearable="!arg.required" :multiple="arg.multiple"></v-select>
                                          <v-select
                                              v-if="arg.type==='agg_freq'" :label="arg.label|translate" v-model="plot.config[arg.name]"
                                              :items="aggFreq"
                                              :clearable="!arg.required"
                                          ></v-select>
                                        <v-radio-group v-if="arg.type==='radio'" :label="arg.label|translate" v-model="plot.config[arg.name]" :mandatory="arg.required">
                                          <v-radio v-for="item in arg.items" :label="item.label|translate" :value="item.value" :color="item.color"></v-radio>
                                        </v-radio-group>
                                      </v-flex>
                                    </v-layout>
                                  </v-card-text>
                                  <v-card-actions>
                                    <v-spacer></v-spacer>
                                      <v-btn @click="cbInternalDiagGenneric=true" v-if="availableWidgets[plot.type].configInterface.data3queryBuilder&&!plot.config.data3query" class="mr-2">{{'Add Data Query'|translate}} </v-btn>
                                      <v-btn @click="cbInternalDiagGenneric=true" v-if="availableWidgets[plot.type].configInterface.data3queryBuilder&&plot.config.data3query" class="mr-2">{{'Edit Data Query'|translate}} </v-btn>
                                      <v-btn @click="plot.config.data3query=null" v-if="availableWidgets[plot.type].configInterface.data3queryBuilder&&plot.config.data3query" class="mr-2">{{'Delete Data Query'|translate}} </v-btn>
                                      <v-dialog v-model="cbInternalDiagGenneric" fullscreen persistent v-if="availableWidgets[plot.type].configInterface.data3queryBuilder">
                                          <chart-builder v-if="cbInternalDiagGenneric" headless-mode :callback="(cfg)=>{plot.config.data3query=cfg}" :initial-value="plot.config.data3query" :default-range="range" v-on:close="cbInternalDiagGenneric=false" :parameters="parameters" :equipment-relationships="equipmentRelationships"></chart-builder>
                                      </v-dialog>
                                    <v-btn @click="plot.editDialog=false">{{'OK'|translate}}</v-btn>
                                  </v-card-actions>
                                </v-card>
                              </v-dialog>
                            </v-layout>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-card>
            <v-card v-if="!loading">
                <v-card-actions>
                    <v-btn class="ml-2" outline @click="goHome()" >
                        {{'Return to Custom Views'|translate}}
                    </v-btn>
                    <v-spacer></v-spacer>
                    <div style="width: 170px;">
                        <v-switch color="success"
                                  v-model="disableVerticalOffset"
                                  :label="'Disable Offset'|translate"
                        ></v-switch>
                    </div>
                    <div style="width: 170px;">
                        <v-switch color="success"
                                  v-model="hideControls"
                                  :label="'Hide Controls'|translate"
                        ></v-switch>
                    </div>
                    <div style="width: 140px;" v-if="editedView">
                        <v-switch color="success"
                                  v-model="editedView.published"
                                  :label="'Published'|translate"
                        ></v-switch>
                    </div>
                    <v-btn
                        color="primary"
                        v-if="editedView"
                        @click="mcdialog=true">
                        <v-icon class="mr-2">fa-bars</v-icon>
                        {{'Menu Config'|translate}}
                    </v-btn>
                  <v-btn color="primary" @click="insertionPoint='end'; masterDialog=true">
                        <v-icon class="mr-2">fa-plus</v-icon> {{'Add'|translate}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            v-show="plotList.length>0"
                            @click="newPlotsName=null; dialog2=true">
                        <v-icon class="mr-2">fa-save</v-icon>
                        {{'Save As'|translate}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            v-show="plotList.length>0"
                            v-if="editedView"
                            @click="saveEdit">
                        <v-icon class="mr-2">fa-save</v-icon>
                        {{'Save'|translate}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            v-show="plotList.length>0"
                            v-if="editedView"
                            @click="exportView">
                        <v-icon class="mr-2">fa-file-export</v-icon>
                        {{'Export'|translate}}
                    </v-btn>
                    <v-btn
                            color="primary"
                            v-show="plotList.length>0"
                            class="mr-2"
                            v-if="editedView"
                            @click="openInView">
                        <v-icon class="mr-2">fa-external-link-alt</v-icon>
                        {{'View'|translate}}
                    </v-btn>

                    <v-dialog v-model="addJsonDialog" max-width="800" persistent>
                        <v-card v-if="addJsonDialog">
                            <v-card-title class="primary white--text title">
                                {{'Import component from JSON'|translate}}
                            </v-card-title>
                            <editor v-model="jsonImport" @init="jsonEditorInit" lang="json" theme="twilight" width="100%" height="500"></editor>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <div style="width: 200px;" v-if="insertionPoint==='start'||insertionPoint==='end'">
                                    <v-select class="mr-2"
                                        :items="insertionOptions"
                                        :label="'Insert at'|translate"
                                        v-model="insertionPoint"
                                    ></v-select>
                                </div>
                                <v-btn class="primary" :disabled="!jsonImport||jsonImport===''" @click="importFromJson">{{'Import'|translate}}</v-btn>
                                <v-btn @click="jsonImport=''; addJsonDialog=false">{{'Cancel'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialog" fullscreen persistent>
                        <chart-builder v-if="dialog" :callback="handleCBSave" :initial-value="chartInitialValue" :default-range="range" v-on:close="dialog=false" :parameters="parameters" :equipment-relationships="equipmentRelationships"></chart-builder>
                    </v-dialog>
                    <v-dialog v-model="dialog2" max-width="300" persistent>
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{'Save as custom view'|translate}}
                            </v-card-title>
                            <v-card-text>
                                <v-text-field :label="'Name'|translate"  v-model="newPlotsName" required></v-text-field>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" @click="savePlots" :disabled="!newPlotsName||newPlotsName===''">{{'Save'|translate}}</v-btn>
                                <v-btn @click="dialog2=false">{{'Cancel'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="dialogAdd" max-width="1000" persistent>
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{'Add Component'|translate}}
                            </v-card-title>                            
                            <v-container fluid>
                                <v-layout wrap align-center justify-center >
                                    <v-flex xs3 v-for="widget in availableWidgets" v-if="widget.public||allowPrivateComponents">
                                        <v-hover v-slot:default="{ hover }">
                                            <v-card 
                                            height="120px" 
                                            class="pa-2 ma-2 cursor-as-pointer"  
                                            @click="addWidget(widget.type,widget.config); dialogAdd=false;"
                                            :elevation="hover ? 12 : 2"
                                            :class="{ 'on-hover': hover }">
                                                <v-layout row>
                                                    <v-spacer></v-spacer>
                                                    <v-icon large class="mt-3">{{widget.icon}}</v-icon>
                                                    <v-spacer></v-spacer>
                                                </v-layout>
                                                <h4 class="mx-1 mt-3 layout justify-center">{{widget.title|translate}}</h4>
                                            </v-card>
                                        </v-hover>
                                    </v-flex>
                                </v-layout>
                            </v-container>              
                            <v-card-actions>  
                                <v-spacer></v-spacer>
                                <div style="width: 200px;" v-if="insertionPoint==='start'||insertionPoint==='end'">
                                    <v-select
                                        class="mr-2"
                                        :items="insertionOptions"
                                        :label="'Insert at'|translate"
                                        v-model="insertionPoint"
                                    ></v-select>
                                </div>
                                <v-btn @click="dialogAdd=false" class="mr-4 ml-2">{{'Cancel'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="masterDialog" max-width="300" persistent>
                        <v-card>
                            <v-card-title class="primary white--text title">
                                {{'Add'|translate}}
                            </v-card-title>
                            <v-card-text>
                                <v-layout column justify-center>
                                    <v-btn color="primary" @click="masterDialog=false; chartInitialValue=null; openDialog();">
                                        <v-icon class="mr-2">fa-plus</v-icon>
                                        {{'Add chart'|translate}}
                                    </v-btn>
                                    <v-btn color="primary" @click="masterDialog=false; dialogAdd=true">
                                        <v-icon class="mr-2">fa-plus</v-icon> {{'Add Component'|translate}}
                                    </v-btn>
                                    <v-btn color="primary" @click="masterDialog=false; addJsonDialog=true">
                                        <v-icon class="mr-2">fa-file-import</v-icon> {{'Import JSON'|translate}}
                                    </v-btn>
                                    <v-btn @click="masterDialog=false">{{'Cancel'|translate}}</v-btn>
                                </v-layout>
                            </v-card-text>
                        </v-card>
                    </v-dialog>
                    <v-dialog v-model="mcdialog" max-width="1200" persistent>
                        <menu-config v-if="mcdialog" closable @close="mcdialog=false"></menu-config>
                    </v-dialog>
                    <v-dialog v-model="equipSetDefaultDialog" max-width="600" persistent>
                        <v-card v-if="equipSetDefaultDialog">
                            <v-card-title class="primary white--text title">
                                {{'Set default equipment for all queries in this view'|translate}}
                            </v-card-title>
                            <v-card-text>
                                <equipment-selector v-model="defaultEquip" :type-filter="editedView.equipmentTypeFilter" :floor-filter="editedView.equipmentFloorFilter"
                                                    :tag-filter="editedView.equipmentTagFilter" ></equipment-selector>
                            </v-card-text>
                            <v-card-actions>
                                <v-spacer></v-spacer>
                                <v-btn class="primary" :disabled="!defaultEquip" @click="setDefaultEquip">{{'Confirm'|translate}}</v-btn>
                                <v-btn @click="defaultEquip=null; equipSetDefaultDialog=false">{{'Cancel'|translate}}</v-btn>
                            </v-card-actions>
                        </v-card>
                    </v-dialog>
                </v-card-actions>
            </v-card>
        </v-flex>

    </v-layout>
</template>

<script>
    import DateRangeSelector from '../components/DateRangeSelector'
    import Data3Chart from "../components/Data3Chart";
    import InlineEditor from "../components/InlineEditor";
    import moment from 'moment'
    import ChartBuilder from "./ChartBuilder";
    import MapWidget from "../components/widgets/MapWidget";
    import HeatmapWidget from "../components/widgets/HeatmapWidget";
    import PointPickerDialog from "../components/PointPickerDialog";
    import EquipmentSelector from "../components/EquipmentSelector";
    import CorrelationWidget from "../components/widgets/CorrelationWidget";
    import OptimizationWidget from "../components/widgets/OptimizationWidget";
    import FaultBreakdownWidget from "../components/widgets/FaultBreakdownWidget";
    import CopSavingsWidget from "../components/widgets/CopSavingsWidget";
    import SensorSelector from "../components/SensorSelector";
    import GraphicSelector from "../components/GraphicSelector";
    import EquipmentGraphicRenderer from "../components/EquipmentGraphicRenderer";
    import FaultEvalWidget from "../components/widgets/FaultEvalWidget";
    import StagingProfileWidget from "../components/widgets/StagingProfileWidget";
    import CoolingLoadForecastWidget from '../components/widgets/CoolingLoadForecastWidget';
    import ChillerSequencingFlaWidget from '../components/widgets/ChillerSequencingFLAWidget';
    import ChillerSequencingDeltaWidget from '../components/widgets/ChillerSequencingDeltaWidget'
    import CoolingLoadVsOatWidget from '../components/widgets/CoolingLoadVsOatWidget'
    import BmsWidget from "@/components/widgets/BmsWidget";
    import ForgeViewerWidget from "@/components/widgets/ForgeViewerWidget";
    import ForgeViewerHeatmapWidget from "@/components/widgets/ForgeViewerHeatmapWidget";
    import MaintenanceSummaryWidget from "@/components/widgets/MaintenanceSummaryWidget";
    import widgetConfig from '../config/widgets/generic.js'
    import ecPresets from '../config/ecPresets/charts.js'
    import customPresets from '../config/cPresets/custom.js'
    import CostBreakdownWidget from "@/components/widgets/CostBreakdownWidget";
    import ImagePicker from "@/components/ImagePicker";
    import SvgWidget from "@/components/widgets/SvgWidget";
    import IssueSummaryWidget from "@/components/widgets/IssueSummaryWidget";
    import TreeMapWidget from "@/components/widgets/TreeMapWidget";
    import FlexibleOptimizationWidget from "@/components/widgets/FlexibleOptimizationWidget";
    import CustomEcWidget from "../components/widgets/CustomEcWidget";
    import MenuConfig from "./MenuConfig";
    import editor from 'vue2-ace-editor'
    import {uniqueid} from "../helper";
    import _ from 'lodash'
    import {mapGetters} from 'vuex'
    import Graphic from "../components/GraphicDialog";
    import FlexibleCopSavingsWidget from "../components/widgets/FlexibleCopSavingsWidget";
    import FaultsReportWidget from "../components/widgets/FaultsReportWidget";
    import NotifBreakdownWidget from "../components/widgets/NotifBreakdownWidget";
    import SensorCalibrationWidget from "@/components/widgets/SensorCalibrationWidget";
    import SolarWidget from "../components/widgets/SolarWidget";
    import AutotunerSelector from "../components/AutotunerSelector";
    import AutotunerWidget from "../components/widgets/AutotunerWidget";
    import ThermalComfortWidget from "../components/widgets/ThermalComfortWidget";
    import DataExportWidget from "../components/widgets/DataExportWidget.vue";
    import OptimizationControlWidget from "../components/widgets/OptimizationControlWidget.vue";
    import OptimizationVizWidget from "../components/widgets/OptimizationVizWidget.vue";
    import ClockControlWidget from "../components/widgets/ClockControlWidget.vue";
    import FormWidget from "@/components/widgets/FormWidget.vue";
    import data3Processor from "@/components/mixins/data3Processor";


    export default {
        name: 'CustomViewBuilder',
        mixins:[data3Processor],
        components: {
            Graphic,
            DateRangeSelector,
            Data3Chart,
            ChartBuilder,
            InlineEditor,
            MapWidget,
            HeatmapWidget,
            PointPickerDialog,
            EquipmentSelector,
            CorrelationWidget,
            OptimizationWidget,
            FaultBreakdownWidget,
            CopSavingsWidget,
            SensorSelector,
            GraphicSelector,
            EquipmentGraphicRenderer,
            FaultEvalWidget,
            StagingProfileWidget,
            CoolingLoadForecastWidget,
            ChillerSequencingFlaWidget,
            ChillerSequencingDeltaWidget,
            CoolingLoadVsOatWidget,
            BmsWidget,
            ForgeViewerWidget,
            ForgeViewerHeatmapWidget,
            MaintenanceSummaryWidget,
            CostBreakdownWidget,
            ImagePicker,
            SvgWidget,
            IssueSummaryWidget,
            TreeMapWidget,
            FlexibleOptimizationWidget,
            CustomEcWidget,
            MenuConfig,
            editor,
            FlexibleCopSavingsWidget,
            FaultsReportWidget,
            NotifBreakdownWidget,
            SensorCalibrationWidget,
            SolarWidget,
            AutotunerSelector,
            AutotunerWidget,
            ThermalComfortWidget,
            DataExportWidget,
            OptimizationControlWidget,
            OptimizationVizWidget,
            ClockControlWidget,
            FormWidget,
        },
        data() {
            return {
                range: {start: moment().subtract(29, "days").format('YYYY-MM-DD'), end: moment().format('YYYY-MM-DD')},
                hideControls:false,
                disableVerticalOffset:false,
                jsonImport:"",
                aggFreq: [
                    {
                        text:this.$options.filters.translate("hour"),
                        value:"H"
                    },{
                        text:this.$options.filters.translate("day"),
                        value:"D"
                    },{
                        text:this.$options.filters.translate("week"),
                        value:"W"
                    },{
                        text:this.$options.filters.translate("month"),
                        value:"M"
                    },{
                        text:this.$options.filters.translate("year"),
                        value:"Y"
                    }
                ],
                aggOpp: ["sum","mean","count","min","max"],
                defaultRanges: ["30 days","current week","current month","current year","last week","last month","last year","this range","yesterday", "today", "live"],
                fab:false,
                pointPickerDiag:false,
                pointPickerDiag2:false,
                cbInternalDiag:false,
                cbInternalDiag2:false,
                cbInternalDiag3:false,
                cbInternalDiag4:false,
                cbInternalDiag5:false,
                cbInternalDiag6:false,
                cbInternalDiag7:false,
                cbInternalDiagGenneric:false,
                flexClasses:[
                    {value:"lg1",text:"1"},
                    {value:"lg2",text:"2"},
                    {value:"lg3",text:"3"},
                    {value:"lg4",text:"4"},
                    {value:"lg5",text:"5"},
                    {value:"lg6",text:"6"},
                    {value:"lg7",text:"7"},
                    {value:"lg8",text:"8"},
                    {value:"lg9",text:"9"},
                    {value:"lg10",text:"10"},
                    {value:"lg11",text:"11"},
                    {value:"lg12",text:"12"},
                ],
                dialog:false,
                mcdialog:false,
                availableWidgets: widgetConfig,
                equipmentRelationships: [],
                availableECPresents:ecPresets,
                availableCustomPresents:customPresets,
                chartInitialValue:null,
                newPlotsName:null,
                equipSetDefaultDialog:false,
                defaultEquip:null,
                loading:false,
                editingIndex:0,
                dialog2:false,
                editedView:null,
                plotList:[],
                parameters:{},
                typeFilters:[],
                floorFilters:[],
                dialogAdd:false ,
                addJsonDialog:false ,
                masterDialog:false ,
                insertionPoint:"end",
                insertionOptions:["start","end"]
            }
        },
        computed: {
            ...mapGetters([
                'userPlots','chartColorways',
            ]),
            availableColorways(){
                return Object.keys(this.chartColorways)
            },
            whiteMode(){
                return (this.editedView&&this.editedView.whiteMode)||!this.unifiedIsThemeDark
            },
            whiteModeIsRelevant(){
                return this.unifiedIsThemeDark
            },
            facility_name() {
                return this.$store.state.pointsListStore.pointsList.facility_name
            },
            allowPrivateComponents () {
                if (this.$store.state.userStore.user) {
                    if (process.env.VUE_APP_EXTERNAL_AUTH&&process.env.VUE_APP_EXTERNAL_AUTH==="msal"&&this.$store.state.userStore.user.content.role==="admin"){
                        return true
                    } if (process.env.VUE_APP_SUPERUSER&&process.env.VUE_APP_SUPERUSER!==""){
                        return this.$store.state.userStore.user.content.user_name.toLowerCase().includes(process.env.VUE_APP_SUPERUSER)
                    } else {
                        return this.$store.state.userStore.user.content.user_name === "jecdavid" || this.$store.state.userStore.user.content.user_name.toLowerCase().includes("carnot")
                    }
                }
                return false;
            },
        },
        methods:{
            applyPresetToEC(plot,ecp){
                if (confirm(this.$options.filters.translate('This will apply the chart preset and override any custom code. Are you sure you want to proceed?')) ){
                    if (!plot.config.settings){
                        plot.config.settings={
                            colorway:"Default"
                        }
                    }
                    plot.config.processorFunction=ecp.processorFunction
                    plot.config.configInterface=ecp.configInterface
                }
            },
            svgEditorInit: function () {
                require('brace/ext/language_tools')
                require('brace/mode/svg')
                require('brace/theme/twilight')
            },
            htmlEditorInit: function () {
                require('brace/ext/language_tools')
                require('brace/mode/html')
                require('brace/theme/twilight')
            },
            jsonEditorInit: function () {
                require('brace/ext/language_tools')
                require('brace/mode/json')
                require('brace/theme/twilight')
            },
            jsEditorInit: function () {
                require('brace/ext/language_tools')
                require('brace/mode/javascript')
                require('brace/theme/twilight')
            },
            goHome(){
                let output = {
                    path: '/custom-views/',
                }
                this.$router.push(output)
            },
            savePlots() {
                let newConfig=JSON.parse(JSON.stringify(this.plotList))
                let me=this
                if(newConfig.length>0){
                    let seizeBearer=new Blob([JSON.stringify(newConfig)], {type: "application/json"})
                    if (seizeBearer.size > 5000000) {
                        alert(this.$options.filters.translate('Custom view too big. Size cannot exceed 5MB.'))
                        this.dialog2=false
                        return
                    }

                    let newPlot={
                        id: uniqueid(),
                        viewType: "plot-list",
                        facility:me.$store.state.pointsListStore.pointsList.facility_name,
                        title: this.newPlotsName,
                        linkTitle: this.newPlotsName,
                        plotList: newConfig
                    }
                    this.$store.dispatch('addUserPlot', newPlot).then(function(){
                        me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Custom view saved')})
                        let output = {
                            path: '/custom-view-builder',
                            query: {
                                view: newPlot.id,
                            }
                        }
                        me.$router.push(output)
                        me.switchToEdit(newPlot.id)
                    })
                }
                this.dialog2=false
            },
            exportView(){
                let newConfig=JSON.parse(JSON.stringify(this.plotList))
                let me=this
                if(newConfig.length>0&&this.editedView){
                    let seizeBearer=new Blob([JSON.stringify(newConfig)], {type: "application/json"})
                    if (seizeBearer.size > 5000000) {
                        alert(this.$options.filters.translate('Custom view too big. Size cannot exceed 5MB.'))
                        return
                    }
                    let newPlot=JSON.parse(JSON.stringify(this.editedView))
                    newPlot.plotList=newConfig
                    if(newPlot.defaultRange&&newPlot.defaultRange==="this range"){
                        newPlot.range=JSON.parse(JSON.stringify(me.range))
                    }
                    this.$copyText(JSON.stringify(newPlot)).then(function (e) {
                        me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Custom view copied to clipboard')})
                    }, function (e) {
                        console.log(e)
                    })
                }
            },
            saveEdit(){
                let newConfig=JSON.parse(JSON.stringify(this.plotList))
                let me=this
                if(newConfig.length>0&&this.editedView){
                    let seizeBearer=new Blob([JSON.stringify(newConfig)], {type: "application/json"})
                    if (seizeBearer.size > 5000000) {
                        alert(this.$options.filters.translate('Custom view too big. Size cannot exceed 5MB.'))
                        return
                    }
                    let newPlot=JSON.parse(JSON.stringify(this.editedView))
                    newPlot.plotList=newConfig
                    if(newPlot.defaultRange&&newPlot.defaultRange==="this range"){
                        newPlot.range=JSON.parse(JSON.stringify(me.range))
                    }
                    this.$store.dispatch('addUserPlot', newPlot).then(function(){
                        me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Changes Saved')})
                    })
                }
            },
            copyChart(plot) {
                let newPlot = JSON.parse(JSON.stringify(plot))
                newPlot.editDialog = false
                newPlot.id = uniqueid()
                this.plotList.splice(this.plotList.indexOf(plot)+1,0, newPlot)
            },
            importFromJson: function () {
                let newItem=JSON.parse(this.jsonImport)
                newItem.id = uniqueid()
                if(this.insertionPoint==="start"){
                    this.plotList.unshift(newItem)
                } else if (this.insertionPoint==="end"){
                    this.plotList.push(newItem)
                } else {
                    this.plotList.splice(this.insertionPoint,0, newItem)
                }
                this.addJsonDialog=false
                this.jsonImport=""
            },
            setDefaultEquip(){
                let newConfig=JSON.parse(JSON.stringify(this.plotList))
                for (let plot of newConfig){
                    if(plot.config&&plot.config.data3query){
                        for (let payload of plot.config.data3query['data-payload']){
                            this.processEquipment(payload, this.defaultEquip)
                        }
                    } else if (plot.config&&plot.config['data-payload']){
                        for (let payload of plot.config['data-payload']){
                            this.processEquipment(payload, this.defaultEquip)
                        }
                    }
                }
                this.plotList=newConfig
                this.defaultEquip=null
                this.equipSetDefaultDialog=false
            },
            exportChart(plot){
                let me=this
                this.$copyText(JSON.stringify(plot)).then(function (e) {
                    me.$store.dispatch('callSnackbar', {text: me.$options.filters.translate('Component copied to clipboard')})
                }, function (e) {
                    console.log(e)
                })
            },
            openDialog(){
                let me=this
                setTimeout(()=>{me.dialog=true;},400)
            },
            handleCBSave(newConfig){
                let newItem={
                    id:uniqueid(),
                    type:'data3-chart',
                    editDialog:false,
                    config:newConfig
                }
                if(this.insertionPoint==="start"){
                    this.plotList.unshift(newItem)
                } else if (this.insertionPoint==="end"){
                    this.plotList.push(newItem)
                } else {
                    this.plotList.splice(this.insertionPoint,0, newItem)
                }
            },
            addWidget(type,config){
                let newItem={
                    id: uniqueid(),
                    type: type,
                    editDialog: false,
                    config: JSON.parse(JSON.stringify(config))
                }
                if(this.insertionPoint==="start"){
                    this.plotList.unshift(newItem)
                } else if (this.insertionPoint==="end"){
                    this.plotList.push(newItem)
                } else {
                    this.plotList.splice(this.insertionPoint,0, newItem)
                }
            },
            handleCBEdit(newConfig){
                this.plotList[this.editingIndex].config=JSON.parse(JSON.stringify(newConfig))
            },
            deleteItem (index) {
                this.plotList.splice(index, 1)
            },
            arrmove(arr, fromIndex, toIndex) {
                let element = arr[fromIndex];
                arr.splice(fromIndex, 1);
                arr.splice(toIndex, 0, element);
            },
            openInView(){
                let url='/user-automated/'+this.editedView.id
                if (process.env.VUE_APP_SINGLE_WINDOW_MODE){
                    window.location.href=url
                } else {
                    window.open(url)
                }
            },
            applyFieldsToParam(fields){
                let parameters = JSON.parse(JSON.stringify(this.parameters))
                for (let field of fields){
                    if(field.name){
                        parameters[field.name]=field.defaultValue
                    }
                }
                this.parameters=parameters
            },
            async switchToEdit(viewId){
                this.loading=true
                await this.$store.dispatch('refreshUserPlots')
                for (let item of this.userPlots){
                    if(item.id===viewId){
                        this.editedView=JSON.parse(JSON.stringify(item))
                        if(this.editedView.defaultRange&&this.editedView.defaultRange==="this range"){
                            this.range=JSON.parse(JSON.stringify(this.editedView.range))
                        } else if (this.editedView.defaultRange&&this.editedView.defaultRange==="live"){
                            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
                            if(maxDate){
                                this.range={start:moment(maxDate).subtract(4,"hours").format('YYYY-MM-DD HH:mm:ss'),end:moment(maxDate).format('YYYY-MM-DD HH:mm:ss')}
                            } else {
                                this.range={start:moment().subtract(4,"hours").format('YYYY-MM-DD HH:mm:ss'),end:moment().format('YYYY-MM-DD HH:mm:ss')}
                            }
                        }
                        let nPlots=JSON.parse(JSON.stringify(item)).plotList
                        let parameters = {}
                        for (let plot of nPlots){
                            plot.editDialog=false
                            if(plot.type==="parameter-widget"&&plot.config.fields){
                                for (let field of plot.config.fields){
                                    if(field.name){
                                        parameters[field.name]=field.defaultValue
                                    }
                                }
                            }
                        }
                        this.parameters=parameters
                        this.plotList=nPlots
                        break
                    }
                }
                this.loading=false
            }
        },
        beforeMount() {
            let me = this;
            let maxDate=this.$store.state.pointsListStore.pointsList.data_max_date;
            if(maxDate){
                this.range={start:moment(maxDate).subtract(29, "days").format('YYYY-MM-DD'),end:moment(maxDate).format('YYYY-MM-DD')}
            }
            this.typeFilters=[...new Set(Object.values(this.$store.state.pointsListStore.pointsList.equipment_details).map(x=>x.equipment_type))].sort()
            this.floorFilters=[...new Set(Object.values(this.$store.state.pointsListStore.pointsList.equipment_details).map(x=>x.floor))].sort()
            let newMappings={}
            for (let equip of Object.values(this.$store.state.pointsListStore.pointsList.equipment_details)){
                newMappings[equip.equipment_id]=equip.equipment_name
            }
            me.equipmentRelationships = JSON.parse(JSON.stringify(this.$store.state.pointsListStore.pointsList.equipment_relationships.map(x => {
                return {
                    type: x.type,
                    equip1: newMappings[x.equip1],
                    equip2: newMappings[x.equip2],
                }
            })))
        },
        async mounted(){
            let viewId = _.get(this.$route.query,'view', null)
            if(viewId&&viewId!==""){
                await this.switchToEdit(viewId)
            }
        }
    }
</script>
<style scoped>
.carnot-custom-report{
    width: 900px;
    margin-left: auto;
    margin-right: auto;
    margin-top: 40px;
    margin-bottom: 40px;
}
.carnot-custom-report-white{
    background-color: white !important;
    color: #424242 !important;
}
</style>
